// import React, { useState, useEffect, useRef } from "react";
// import BlogDelete from "./BlogDelete";
// import BlogArchive from "./BlogArchive";
// import { BASE_URL, DOMAIN_URL } from "../../config";
// import axios from "axios";

// // FIXED: Enhanced Rich Text Editor Component
// const RichTextEditor = ({ value, onChange, placeholder }) => {
//   const editorRef = useRef(null);

//   useEffect(() => {
//     if (editorRef.current && value !== editorRef.current.innerHTML) {
//       editorRef.current.innerHTML = value;
//     }
//   }, [value]);

//   const handleInput = () => {
//     if (editorRef.current) {
//       onChange(editorRef.current.innerHTML);
//     }
//   };

//   const formatText = (command, value = null) => {
//     document.execCommand(command, false, value);
//     editorRef.current.focus();
//     handleInput();
//   };

//   const insertLink = () => {
//     const url = prompt("Enter URL:");
//     if (url) {
//       formatText("createLink", url);
//     }
//   };

//   return (
//     <div className="border border-gray-300 rounded-lg overflow-hidden">
//       {/* Enhanced Toolbar */}
//       <div className="flex flex-wrap gap-1 p-2 border-b border-gray-200 bg-gray-50">
//         <button
//           type="button"
//           onClick={() => formatText("bold")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 font-bold text-sm"
//           title="Bold"
//         >
//           B
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("italic")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 italic text-sm"
//           title="Italic"
//         >
//           I
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("underline")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 underline text-sm"
//           title="Underline"
//         >
//           U
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("strikeThrough")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 line-through text-sm"
//           title="Strike Through"
//         >
//           S
//         </button>

//         <div className="w-px h-6 bg-gray-300 mx-1"></div>

//         <button
//           type="button"
//           onClick={() => formatText("insertUnorderedList")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Bullet List"
//         >
//           • List
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("insertOrderedList")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Numbered List"
//         >
//           1. List
//         </button>

//         <div className="w-px h-6 bg-gray-300 mx-1"></div>

//         <button
//           type="button"
//           onClick={() => formatText("justifyLeft")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Align Left"
//         >
//           ⬅
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("justifyCenter")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Align Center"
//         >
//           ↔
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("justifyRight")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Align Right"
//         >
//           ➡
//         </button>

//         <div className="w-px h-6 bg-gray-300 mx-1"></div>

//         <button
//           type="button"
//           onClick={insertLink}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Insert Link"
//         >
//           🔗
//         </button>

//         <select
//           onChange={(e) => formatText("fontSize", e.target.value)}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           defaultValue="3"
//         >
//           <option value="1">Small</option>
//           <option value="3">Normal</option>
//           <option value="5">Large</option>
//           <option value="7">Huge</option>
//         </select>
//       </div>

//       {/* FIXED: Editor with proper direction and styling */}
//       <div
//         ref={editorRef}
//         contentEditable
//         onInput={handleInput}
//         className="p-3 min-h-[200px] focus:outline-none text-left"
//         style={{
//           minHeight: "200px",
//           direction: "ltr",
//           textAlign: "left",
//           unicodeBidi: "embed",
//         }}
//         data-placeholder={placeholder}
//         suppressContentEditableWarning={true}
//       />
//     </div>
//   );
// };

// const Blog = ({ dimension, fromTabs }) => {
//   // Navigation state
//   const [currentView, setCurrentView] = useState("home");
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [openPostMenus, setOpenPostMenus] = useState({});
//   const [postStates, setPostStates] = useState({});
//   const menuRef = useRef(null);

//   // Search state
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResults, setSearchResults] = useState([]);

//   // Blog form states
//   const [isAddBlogOpen, setIsAddBlogOpen] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [formData, setFormData] = useState({
//     title: "",
//     content: "",
//     main_image_url: "",
//     category_id: "",
//     tags: [],
//     status: "draft",
//     is_archived: false,
//   });

//   // Category form states
//   const [isAddCategoryOpen, setIsAddCategoryOpen] = useState(false);
//   const [isSubmittingCategory, setIsSubmittingCategory] = useState(false);
//   const [categoryFormData, setCategoryFormData] = useState({
//     name: "",
//   });

//   // Category states
//   const [categories, setCategories] = useState([]);
//   const [loadingCategories, setLoadingCategories] = useState(false);
//   const [categoryError, setCategoryError] = useState("");

//   // File handling states
//   const [mainImageFile, setMainImageFile] = useState(null);
//   const [thumbnailImageFile, setThumbnailImageFile] = useState(null);
//   const [mainImagePreview, setMainImagePreview] = useState("");
//   const [thumbnailImagePreview, setThumbnailImagePreview] = useState("");

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   const urlParams = new URLSearchParams(window.location.search);
//   const token = urlParams.get("token");
//   const [tagsInput, setTagsInput] = useState("");

//   // Blog states
//   const [blogPosts, setBlogPosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [totalBlogs, setTotalBlogs] = useState(0);

//   // Add these state variables after your existing states
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editingBlogId, setEditingBlogId] = useState(null);
//   const [editingBlogData, setEditingBlogData] = useState(null);

//   // Add these new states for category management
//   const [isManageCategoriesOpen, setIsManageCategoriesOpen] = useState(false);
//   const [editingCategory, setEditingCategory] = useState(null);
//   const [isEditCategoryOpen, setIsEditCategoryOpen] = useState(false);
//   const [categoriesList, setCategoriesList] = useState([]);
//   const [loadingCategoriesList, setLoadingCategoriesList] = useState(false);

//   // FIXED: Fetch blogs function with proper loading check
//   const fetchMyBlogs = async (page = 1, limit = itemsPerPage) => {
//     // Prevent multiple simultaneous calls
//     if (loading) return;

//     setLoading(true);
//     setError("");

//     console.log("Fetching blogs with:", {
//       page,
//       limit,
//       token: token ? "exists" : "missing",
//     });

//     try {
//       const response = await axios.get(`${BASE_URL}/blogs/user/my-blogs`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         params: {
//           page,
//           limit,
//         },
//       });

//       console.log("Blog API Response:", response.data);

//       if (response.data && response.data.data) {
//         // Filter out archived blogs from the main view
//         const activeBlogs = response.data.data.filter((blog) => {
//           // Handle both boolean and string values for is_archived
//           const isArchived =
//             blog.is_archived === true ||
//             blog.is_archived === "true" ||
//             blog.is_archived === 1;
//           return !isArchived;
//         });

//         console.log("Original blogs count:", response.data.data.length);
//         console.log("Active blogs count:", activeBlogs.length);
//         console.log(
//           "Filtered out archived blogs:",
//           response.data.data.filter(
//             (blog) =>
//               blog.is_archived === true ||
//               blog.is_archived === "true" ||
//               blog.is_archived === 1
//           )
//         );

        
//                 setTotalBlogs(response.data.total || response.data.data.length);
//         setBlogPosts(activeBlogs);
// setTotalBlogs(response.data.total || response.data.data.length);

// // FIX: Sync toggle status with real blog status
// const statusMap = {};
// activeBlogs.forEach((post) => {
//   statusMap[post.blog_id] = post.status === "published";
// });
// setPostStates(statusMap);

//       }
//     } catch (error) {
//       console.error("Error fetching blogs:", error);
//       console.error("Error response:", error.response?.data);
//       setError("Failed to load blogs");
//       setBlogPosts([]);
//     } finally {
//       setLoading(false);
//     }
//   };
//   // Add this state at the top of your component
//   const [expandedTags, setExpandedTags] = useState({});
//   // Add this function to handle tag expansion
//   const toggleTagExpansion = (postId) => {
//     setExpandedTags((prev) => ({
//       ...prev,
//       [postId]: !prev[postId],
//     }));
//   };

//   // FIXED: Function to fetch categories
//   const fetchCategories = async () => {
//     setLoadingCategories(true);
//     setCategoryError("");

//     try {
//       const response = await axios.get(`${BASE_URL}/blogs/categories`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (
//         response.data &&
//         response.data.data &&
//         response.data.data.length > 0
//       ) {
//         setCategories(response.data.data);
//       } else {
//         setCategories([]);
//         setCategoryError(
//           "No categories found. Please create a category first."
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//       setCategoryError("Failed to load categories");
//       setCategories([]);
//     } finally {
//       setLoadingCategories(false);
//     }
//   };

//   // FIXED: Function to create category
//   const createCategory = async (categoryData) => {
//     setIsSubmittingCategory(true);

//     try {
//       const response = await axios.post(
//         ` ${BASE_URL}/blogs/categories`,
//         {
//           name: categoryData.name,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 201) {
//         setIsAddCategoryOpen(false);
//         setCategoryFormData({ name: "" });
//         await fetchCategories();
//         alert("Category created successfully!");
//         return response.data;
//       }
//     } catch (error) {
//       console.error("Error creating category:", error);
//       if (error.response) {
//         alert(
//           `Error: ${error.response.data.message || "Failed to create category"}`
//         );
//       } else {
//         alert("Error creating category");
//       }
//     } finally {
//       setIsSubmittingCategory(false);
//     }
//   };
//   // Fetch all categories for management
//   const fetchCategoriesForManagement = async () => {
//     setLoadingCategoriesList(true);
//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await fetch(
//         `${BASE_URL}/blogs/categories?page=1&limit=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         setCategoriesList(result.data || []);
//       }
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//     } finally {
//       setLoadingCategoriesList(false);
//     }
//   };

//   // Handle edit category
//   const handleEditCategory = (category) => {
//     setEditingCategory(category);
//     setCategoryFormData({ name: category.category_name });
//     setIsEditCategoryOpen(true);
//     setIsManageCategoriesOpen(false);
//   };

//   // Handle category update
//   const handleCategoryUpdate = async (e) => {
//     e.preventDefault();
//     setIsSubmittingCategory(true);

//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await fetch(
//         `${BASE_URL}/blogs/categories/${editingCategory.category_id}`,
//         {
//           method: "PATCH",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ name: categoryFormData.name }),
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         alert(result.message || "Category updated successfully");
//         setIsEditCategoryOpen(false);
//         setEditingCategory(null);
//         setCategoryFormData({ name: "" });
//         fetchCategories(); // Refresh dropdown
//         fetchCategoriesForManagement(); // Refresh management list
//       } else {
//         const error = await response.json();
//         alert(error.message || "Failed to update category");
//       }
//     } catch (error) {
//       console.error("Error updating category:", error);
//       alert("Failed to update category");
//     } finally {
//       setIsSubmittingCategory(false);
//     }
//   };

//   // Handle delete category
//   const handleDeleteCategory = async (categoryId, categoryName) => {
//     if (
//       window.confirm(
//         `Are you sure you want to delete "${categoryName}"? This action cannot be undone.`
//       )
//     ) {
//       try {
//         const token = localStorage.getItem("authToken");
//         const response = await fetch(
//           `${BASE_URL}/blogs/categories/${categoryId}`,
//           {
//             method: "DELETE",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (response.ok) {
//           const result = await response.json();
//           alert(result.message || "Category deleted successfully");
//           fetchCategories(); // Refresh dropdown
//           fetchCategoriesForManagement(); // Refresh management list
//         } else {
//           const error = await response.json();
//           alert(error.message || "Failed to delete category");
//         }
//       } catch (error) {
//         console.error("Error deleting category:", error);
//         alert("Failed to delete category");
//       }
//     }
//   };

//   // Open category management modal
//   const openManageCategories = () => {
//     setIsManageCategoriesOpen(true);
//     fetchCategoriesForManagement();
//   };

//   // Close category management modal
//   const closeManageCategories = () => {
//     setIsManageCategoriesOpen(false);
//     setCategoriesList([]);
//   };

//   // Close edit category modal
//   const closeEditCategory = () => {
//     setIsEditCategoryOpen(false);
//     setEditingCategory(null);
//     setCategoryFormData({ name: "" });
//   };
//   // FIXED: Search functionality with debouncing
//   useEffect(() => {
//     const delayedSearch = setTimeout(() => {
//       if (searchTerm.trim()) {
//         const filtered = blogPosts.filter(
//           (post) =>
//             post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (post.category?.category_name &&
//               post.category.category_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase()))
//         );
//         setSearchResults(filtered);
//       } else {
//         setSearchResults([]);
//       }
//     }, 300);

//     return () => clearTimeout(delayedSearch);
//   }, [searchTerm, blogPosts]);

//   // FIXED: Fetch blogs when page changes - THIS IS THE KEY FIX
//   useEffect(() => {
//     if (currentView === "home") {
//       fetchMyBlogs(currentPage, itemsPerPage);
//     }
//   }, [currentPage, currentView, token]);

//   // Fetch categories when add blog modal opens
//   useEffect(() => {
//     if (isAddBlogOpen) {
//       fetchCategories();
//     }
//   }, [isAddBlogOpen]);

//   // Close menu when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//       if (!event.target.closest(".post-menu")) {
//         setOpenPostMenus({});
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Reset pagination when view changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [currentView]);

//   // Navigation handler
//   const handleNavigation = (view) => {
//     if (view !== currentView) {
//       setIsAnimating(true);
//       setIsMenuOpen(false);
//       setTimeout(() => {
//         setCurrentView(view);
//         setIsAnimating(false);
//       }, 150);
//     } else {
//       setIsMenuOpen(false);
//     }
//   };

//   // Handle post menu toggle
//   const togglePostMenu = (postId) => {
//     setOpenPostMenus((prev) => ({
//       ...prev,
//       [postId]: !prev[postId],
//     }));
//   };

//   // // Handle post actions
//   // const handlePostAction = (action, postId) => {
//   //   console.log(`${action} post:`, postId);
//   //   setOpenPostMenus({});
//   // };
//   // Update the handlePostAction function
//   // Replace your handlePostAction function with this:
//   const handlePostAction = async (action, postId) => {
//     console.log("handlePostAction called:", action, postId); // Debug log
//     setOpenPostMenus({});
//     if (action === "edit") {
//       handleEditBlog(postId);
//       return;
//     }
//     if (action === "delete") {
//       try {
//         // Use the token that's already available in the component scope
//         console.log("Token found:", token ? "YES" : "NO"); // Debug log
//         console.log("Attempting to soft delete blog:", postId); // Debug log

//         const response = await fetch(`${BASE_URL}/blogs/${postId}`, {
//           method: "DELETE",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`, // Use the token from component scope
//           },
//         });

//         console.log("Delete response status:", response.status); // Debug log

//         if (response.ok) {
//           const result = await response.json();
//           console.log("Blog soft deleted successfully:", result);

//           // Refresh the blog list
//           await fetchMyBlogs(currentPage, itemsPerPage);

//           alert("Blog post moved to trash successfully");
//         } else {
//           const errorData = await response.json();
//           console.error("Failed to delete blog post:", errorData);
//           alert("Failed to delete blog post: " + errorData.message);
//         }
//       } catch (error) {
//         console.error("Error deleting blog post:", error);
//         alert("Error deleting blog post: " + error.message);
//       }
//     }
//     // Handle archive action
//     if (action === "archive") {
//       // Show confirmation dialog
//       const confirmed = window.confirm(
//         "Are you sure you want to archive this blog post?"
//       );

//       if (!confirmed) {
//         return;
//       }
//       try {
//         console.log("Token found:", token ? "YES" : "NO");
//         console.log("Attempting to archive blog:", postId);

//         const response = await fetch(`${BASE_URL}/blogs/${postId}/archive`, {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         console.log("Archive response status:", response.status);
//         if (response.ok) {
//           const result = await response.json();
//           console.log("Blog archived successfully:", result);

//           // Refresh the blog list
//           await fetchMyBlogs(currentPage, itemsPerPage);

//           alert("Blog post archived successfully!");
//         } else {
//           const errorData = await response.json();
//           console.error("Failed to archive blog post:", errorData);
//           alert("Failed to archive blog post: " + errorData.message);
//         }
//       } catch (error) {
//         console.error("Error archiving blog post:", error);
//         alert("Error archiving blog post: " + error.message);
//       }
//     }
//   };

//   // Add this function after your handlePostAction function
//   const handleEditBlog = async (blogId) => {
//     console.log("Editing blog:", blogId);

//     try {
//       // Find the blog data from current posts
//       const blogToEdit = currentPosts.find((post) => post.blog_id === blogId);

//       if (!blogToEdit) {
//         alert("Blog not found");
//         return;
//       }

//       console.log("Blog to edit:", blogToEdit);

//       // Set form data with existing blog data
//       setFormData({
//         title: blogToEdit.title || "",
//         content: blogToEdit.content || "",
//         main_image_url: blogToEdit.main_image_url || "",
//         category_id: blogToEdit.category_id || "",
//         tags: blogToEdit.tags || [],
//         status: blogToEdit.status || "draft",
//         is_archived: blogToEdit.is_archived || false,
//       });

//       // Set tags input for display
//       setTagsInput(blogToEdit.tags ? blogToEdit.tags.join(", ") : "");

//       // Set edit mode
//       setIsEditMode(true);
//       setEditingBlogId(blogId);
//       setEditingBlogData(blogToEdit);

//       // Set main image preview if exists
//       if (blogToEdit.main_image_url) {
//         setMainImagePreview(blogToEdit.main_image_url);
//       }

//       // Open the blog form modal
//       setIsAddBlogOpen(true);

//       // Fetch categories for the form
//       fetchCategories();
//     } catch (error) {
//       console.error("Error preparing blog for edit:", error);
//       alert("Error loading blog for editing");
//     }
//   };

//   const handleToggle = async (blogId) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const currentPost = displayPosts.find((post) => post.blog_id === blogId);
//       const currentStatus = currentPost?.status || "draft";
//       const newStatus = currentStatus === "draft" ? "published" : "draft";

//       const response = await fetch(
//         `${BASE_URL}/blogs/${blogId}/toggle-status`,
//         {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ status: newStatus }),
//         }
//       );

//       if (response.ok) {
//         // Update local state
//         setPostStates((prev) => ({
//           ...prev,
//           [blogId]: newStatus === "published",
//         }));

//         // Show confirmation message
//         const message =
//           newStatus === "published"
//             ? "Blog post published successfully!"
//             : "Blog post saved as draft!";

//         alert(message); // Or use toast notification

//         // Refresh the blog list
//         fetchMyBlogs(currentPage, itemsPerPage);
//       }
//     } catch (error) {
//       console.error("Error updating blog status:", error);
//       alert("Failed to update blog status");
//     }
//   };
//   // Get status text and color
//   const getStatusDisplay = (postId) => {
//     const isOn = postStates[postId];
//     return {
//       text: isOn ? "Published" : "Draft",
//       color: isOn ? "text-green-600" : "text-gray-400",
//     };
//   };

//   // FIXED: Get display posts for server-side pagination
//   const getDisplayPosts = () => {
//     if (searchTerm.trim()) {
//       return blogPosts.filter(
//         (post) =>
//           (post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (post.category?.category_name &&
//               post.category.category_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase()))) &&
//           (post.status === "draft" || post.status === "published")
//       );
//     }
//     return blogPosts.filter(
//       (post) => post.status === "draft" || post.status === "published"
//     );
//   };

//   const displayPosts = getDisplayPosts();

//   // FIXED: Server-side pagination - DON'T slice the data again
//   const currentPosts = displayPosts; // Use all posts from current page

//   // FIXED: Calculate total pages from server response
//   const totalPages = Math.max(1, Math.ceil(totalBlogs / itemsPerPage));

//   // FIXED: Pagination handlers
//   const goToPage = (page) => {
//     setCurrentPage(page);
//     // fetchMyBlogs will be called automatically by useEffect
//   };

//   const goToPrevious = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const goToNext = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   // Color gradients for fallback
//   const gradients = [
//     "from-pink-100 to-pink-200",
//     "from-orange-100 to-orange-200",
//     "from-green-100 to-green-200",
//     "from-purple-100 to-purple-200",
//     "from-blue-100 to-blue-200",
//     "from-yellow-100 to-yellow-200",
//   ];

//   // Category colors for badges
//   const getCategoryColor = (category) => {
//     const colors = {
//       Rings: "bg-purple-50 text-purple-600",
//       Bracelets: "bg-blue-50 text-blue-600",
//       Bangles: "bg-green-50 text-green-600",
//       Necklaces: "bg-pink-50 text-pink-600",
//       gold: "bg-yellow-50 text-yellow-600",
//       Chains: "bg-indigo-50 text-indigo-600",
//       Pendants: "bg-red-50 text-red-600",
//     };
//     return colors[category] || "bg-yellow-50 text-yellow-600";
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   // Handle category form input changes
//   const handleCategoryInputChange = (e) => {
//     const { name, value } = e.target;
//     setCategoryFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Handle category selection
//   const handleCategoryChange = (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       category_id: e.target.value,
//     }));
//   };

//   // Handle tags input
//   const handleTagsChange = (e) => {
//     const inputValue = e.target.value;
//     setTagsInput(inputValue);

//     const tags = inputValue
//       .split(",")
//       .map((tag) => tag.trim())
//       .filter((tag) => tag)
//       .filter((tag, index, arr) => arr.indexOf(tag) === index);

//     setFormData((prev) => ({
//       ...prev,
//       tags: tags,
//     }));
//   };

//   // Remove individual tag
//   const removeTag = (indexToRemove) => {
//     const newTags = formData.tags.filter((_, index) => index !== indexToRemove);
//     setFormData((prev) => ({
//       ...prev,
//       tags: newTags,
//     }));
//     setTagsInput(newTags.join(", "));
//   };

//   // FIXED: Handle search input
//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);

//     // If search is cleared, fetch fresh data
//     if (!e.target.value.trim()) {
//       fetchMyBlogs(1, itemsPerPage);
//     }
//   };

//   // Handle main image file selection
//   const handleMainImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
//       if (!allowedTypes.includes(file.type)) {
//         alert("Please select a valid image file (JPEG, PNG, or WebP)");
//         return;
//       }

//       if (file.size > 10 * 1024 * 1024) {
//         alert("File size must be less than 10MB");
//         return;
//       }

//       setMainImageFile(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setMainImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Handle thumbnail image file selection
//   const handleThumbnailImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setThumbnailImageFile(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setThumbnailImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Update your existing closeBlogPopup function
//   const closeBlogPopup = () => {
//     setIsAddBlogOpen(false);

//     // Reset form data
//     setFormData({
//       title: "",
//       content: "",
//       main_image_url: "",
//       category_id: "",
//       tags: [],
//       status: "draft",
//       is_archived: false,
//     });

//     // Reset all states
//     setTagsInput("");
//     setMainImageFile(null);
//     setThumbnailImageFile(null);
//     setMainImagePreview("");
//     setThumbnailImagePreview("");
//     setCategoryError("");
//     setCategories([]);

//     // Reset edit mode
//     setIsEditMode(false);
//     setEditingBlogId(null);
//     setEditingBlogData(null);
//   };

//   // Close category popup
//   const closeCategoryPopup = () => {
//     setIsAddCategoryOpen(false);
//     setCategoryFormData({
//       name: "",
//     });
//   };
// const cleanTags = (tagsInput) => {
//   if (!tagsInput) return [];

//   if (Array.isArray(tagsInput)) {
//     return tagsInput.map(tag => tag.trim()).filter(Boolean);
//   }

//   return tagsInput
//     .split(',')
//     .map(tag => tag.trim())
//     .filter(tag => tag.length > 0);
// };

//   const handleBlogSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.title.trim()) {
//       alert("Please enter a title");
//       return;
//     }

//     if (!formData.content.trim()) {
//       alert("Please enter content");
//       return;
//     }

//     if (!formData.category_id) {
//       alert("Please select a category");
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const cleanedTags = cleanTags(formData.tags);
//       console.log("Cleaned tags:", cleanedTags);

//       const hasImages = mainImageFile || thumbnailImageFile;

//       if (!hasImages) {
//         // No images - use JSON
//         const jsonData = {
//           title: formData.title,
//           content: formData.content,
//           category_id: formData.category_id,
//           tags: cleanedTags.length > 0 ? cleanedTags : undefined,
//           status: formData.status,
//           is_archived: false, // FIXED: Always false for new blogs
//         };

//         console.log("Sending JSON data:", jsonData);

//         // Choose endpoint based on edit mode
//         const url = isEditMode
//           ? `${BASE_URL}/blogs/${editingBlogId}`
//           : `${BASE_URL}/blogs`;
//         const method = isEditMode ? "PATCH" : "POST";

//         const response = await axios({
//           method,
//           url,
//           data: jsonData,
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (response.status === 200 || response.status === 201) {
//           closeBlogPopup();
//           alert(
//             isEditMode
//               ? "Blog updated successfully!"
//               : "Blog created successfully!"
//           );
//           fetchMyBlogs(currentPage, itemsPerPage);
//         }
//       } else {
//         // With images - use FormData
//         const submitData = new FormData();
//         submitData.append("title", formData.title);
//         submitData.append("content", formData.content);
//         submitData.append("category_id", formData.category_id);
//         submitData.append("status", formData.status);
//         submitData.append("is_archived", "false"); // FIXED: Always false for new blogs

//         if (cleanedTags.length > 0) {
//           cleanedTags.forEach((tag) => {
//             submitData.append("tags", tag);
//           });
//         }

//         if (mainImageFile) {
//           submitData.append("main_image", mainImageFile);
//         }

//         if (thumbnailImageFile) {
//           submitData.append("thumbnail_image", thumbnailImageFile);
//         }

//         console.log("Sending FormData with tags:", cleanedTags);

//         // Choose endpoint based on edit mode
//         const url = isEditMode
//           ? `${BASE_URL}/blogs/${editingBlogId}`
//           : `${BASE_URL}/blogs`;
//         const method = isEditMode ? "PATCH" : "POST";

//         const response = await axios({
//           method,
//           url,
//           data: submitData,
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         });

//         if (response.status === 200 || response.status === 201) {
//           closeBlogPopup();
//           alert(
//             isEditMode
//               ? "Blog updated successfully!"
//               : "Blog created successfully!"
//           );
//           fetchMyBlogs(currentPage, itemsPerPage);
//         }
//       }
//     } catch (error) {
//       console.error("Error with blog operation:", error);
//       if (error.response) {
//         console.error("Full response data:", error.response.data);
//         if (error.response.data && error.response.data.message) {
//           console.error(
//             "Detailed error messages:",
//             error.response.data.message
//           );
//         }
//         alert(
//           `Error: ${JSON.stringify(
//             error.response.data.message || "Operation failed"
//           )}`
//         );
//       } else {
//         alert("Error with blog operation");
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
//   // Submit category form
//   const handleCategorySubmit = async (e) => {
//     e.preventDefault();

//     if (!categoryFormData.name.trim()) {
//       alert("Please enter a category name");
//       return;
//     }

//     await createCategory(categoryFormData);
//   };

//   return (
//     <div className=" flex flex-col bg-gray-50">
//       {/* Only show header and main content when on home page */}
//       {currentView === "home" && (
//         <>
//           {/* Header */}
//           <div className="flex-shrink-0 bg-white shadow-sm border-b">
//             <div className="px-6 py-4">
//               <div className="flex items-center justify-between">
//                 {/* Hamburger Menu */}
//                 <div className="relative" ref={menuRef}>
//                   <button
//                     onClick={() => setIsMenuOpen(!isMenuOpen)}
//                     className="p-2 hover:bg-gray-100 rounded transition-colors"
//                   >
//                     <svg
//                       className="w-6 h-6"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M4 6h16M4 12h16M4 18h16"
//                       />
//                     </svg>
//                   </button>

//                   {isMenuOpen && (
//                     <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden">
//                       <div className="py-2">
//                         <button
//                           onClick={() => handleNavigation("home")}
//                           className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center ${
//                             currentView === "home"
//                               ? "bg-blue-50 text-blue-600 border-r-2 border-blue-600"
//                               : "text-gray-700"
//                           }`}
//                         >
//                           <svg
//                             className="w-4 h-4 mr-3"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
//                             />
//                           </svg>
//                           Home
//                         </button>

//                         <button
//                           onClick={() => handleNavigation("delete")}
//                           className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center ${
//                             currentView === "delete"
//                               ? "bg-red-50 text-red-600 border-r-2 border-red-600"
//                               : "text-gray-700"
//                           }`}
//                         >
//                           <svg
//                             className="w-4 h-4 mr-3"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                             />
//                           </svg>
//                           Delete
//                         </button>

//                         <button
//                           onClick={() => handleNavigation("archive")}
//                           className={`w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center ${
//                             currentView === "archive"
//                               ? "bg-yellow-50 text-yellow-600 border-r-2 border-yellow-600"
//                               : "text-gray-700"
//                           }`}
//                         >
//                           <svg
//                             className="w-4 h-4 mr-3"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h14a2 2 0 002-2V8m-9 4h4"
//                             />
//                           </svg>
//                           Archive
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 {/* Action Buttons */}
//                 <div className="flex gap-4">
//                   <button
//                     onClick={() => setIsAddBlogOpen(true)}
//                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     Add Blog
//                   </button>
//                   <button
//                     onClick={() => setIsAddCategoryOpen(true)}
//                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
//                   >
//                     Add Category
//                   </button>
//                   <button
//                     onClick={openManageCategories}
//                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
//                   >
//                     Manage Categories
//                   </button>

//                   {/* Search Bar */}
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Search..."
//                       value={searchTerm}
//                       onChange={handleSearchChange}
//                       className="pl-4 pr-10 py-2 border border-gray-300 rounded w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                     <button className="absolute right-2 top-1/2 transform -translate-y-1/2">
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                         />
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Main Content */}
//           <div className="flex-1 overflow-auto">
//             <div
//               className={`px-6 py-6 transition-all duration-300 ${
//                 isAnimating
//                   ? "opacity-50 transform translate-x-4"
//                   : "opacity-100 transform translate-x-0"
//               }`}
//             >
//               <div className="mb-6">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-4">
//                     <h2 className="text-xl font-semibold text-gray-800">
//                       Blog Posts
//                     </h2>
//                     {!loading && displayPosts.length > 0 && (
//                       <span className="text-sm text-gray-600">
//                         Page {currentPage} of {totalPages} ({totalBlogs} total
//                         blogs)
//                       </span>
//                     )}
//                   </div>

//                   {/* Pagination Controls in Header */}
//                   {!loading && totalPages > 1 && (
//                     <div className="flex items-center space-x-1">
//                       <button
//                         onClick={goToPrevious}
//                         disabled={currentPage === 1}
//                         className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                       >
//                         Previous
//                       </button>

//                       {Array.from({ length: totalPages }, (_, i) => i + 1).map(
//                         (page) => (
//                           <button
//                             key={page}
//                             onClick={() => goToPage(page)}
//                             className={`px-3 py-1 text-sm border rounded min-w-[32px] ${
//                               currentPage === page
//                                 ? "bg-blue-500 text-white border-blue-500"
//                                 : "border-gray-300 hover:bg-gray-50"
//                             }`}
//                           >
//                             {page}
//                           </button>
//                         )
//                       )}

//                       <button
//                         onClick={goToNext}
//                         disabled={currentPage === totalPages}
//                         className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
//                       >
//                         Next
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//               {/* Loading State */}
//               {loading && (
//                 <div className="flex justify-center items-center py-16">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//                 </div>
//               )}
//               {/* Error State */}
//               {error && (
//                 <div className="text-center py-16">
//                   <p className="text-red-600 text-lg">{error}</p>
//                   <button
//                     onClick={() => fetchMyBlogs(currentPage, itemsPerPage)}
//                     className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//                   >
//                     Try Again
//                   </button>
//                 </div>
//               )}
//               {/* Blog Posts Grid */}
//               {/* Blog Posts Grid */}
//               {!loading && !error && displayPosts.length > 0 && (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
//                   {displayPosts.map((post, index) => {
//                     const status = getStatusDisplay(post.blog_id);
//                     return (
//                       <div
//                         key={post.blog_id}
//                         className="group relative"
//                         style={{ minHeight: "420px" }} // Fixed height for consistency
//                       >
//                         {/* Main Card - Fixed Structure */}
//                         <div
//                           className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer relative"
//                           style={{
//                             minHeight: "530px",
//                             height: expandedTags[post.blog_id]
//                               ? "auto"
//                               : "420px",
//                           }}
//                         >
//                           {/* Post Menu Button */}
//                           <div className="absolute top-3 right-3 z-10">
//                             <button
//                               onClick={() => togglePostMenu(post.blog_id)}
//                               className="p-2 bg-white/90 hover:bg-white rounded-lg shadow-md transition-colors border border-gray-200"
//                             >
//                               <svg
//                                 className="w-4 h-4"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M4 6h16M4 12h16M4 18h16"
//                                 />
//                               </svg>
//                             </button>

//                             {/* Dropdown Menu */}
//                             {openPostMenus[post.blog_id] && (
//                               <div className="absolute top-full right-0 mt-2 w-32 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden post-menu">
//                                 <div className="py-2">
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                       handlePostAction("edit", post.blog_id);
//                                     }}
//                                     className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-blue-600"
//                                   >
//                                     Edit
//                                   </button>
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                       handlePostAction("archive", post.blog_id);
//                                     }}
//                                     className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-yellow-600"
//                                   >
//                                     Archive
//                                   </button>
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                       handlePostAction("delete", post.blog_id);
//                                     }}
//                                     className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-red-600"
//                                   >
//                                     Delete
//                                   </button>
//                                 </div>
//                               </div>
//                             )}
//                           </div>

//                           {/* Image - Fixed Height */}
//                           <div className="relative" style={{ height: "300px" }}>
//                             {post.main_image_url ? (
//                               <img
//                                 src={post.main_image_url}
//                                 alt={post.title}
//                                 className="w-full h-full object-cover"
//                               />
//                             ) : (
//                               <div
//                                 className={`w-full h-full bg-gradient-to-br ${
//                                   gradients[index % gradients.length]
//                                 } flex items-center justify-center`}
//                               >
//                                 <span className="text-gray-500 text-lg font-medium">
//                                   No Image
//                                 </span>
//                               </div>
//                             )}
//                           </div>

//                           {/* Content - Fixed Layout */}
//                           <div
//                             className="p-4 flex flex-col"
//                             style={{
//                               minHeight: "220px",
//                               height: expandedTags[post.blog_id]
//                                 ? "auto"
//                                 : "220px",
//                             }}
//                           >
//                             <div className="flex justify-between items-start text-xs text-gray-600 mb-2">
//                               <span
//                                 className={`px-2 py-1 rounded text-xs ${getCategoryColor(
//                                   post.category?.category_name
//                                 )}`}
//                               >
//                                 {post.category?.category_name ||
//                                   "Uncategorized"}
//                               </span>
//                               <span>
//                                 {new Date(post.created_at).toLocaleDateString()}
//                               </span>
//                             </div>

//                             <h3
//                               className="font-semibold text-gray-800 mb-3 text-sm text-center line-clamp-2"
//                               style={{ height: "40px" }}
//                             >
//                               {post.title}
//                             </h3>
//                             {/* Tags - Dynamic Height Container */}
//                             <div
//                               className="mb-3"
//                               style={{
//                                 minHeight: "60px",
//                                 height: expandedTags[post.blog_id]
//                                   ? "auto"
//                                   : "60px",
//                                 overflow: expandedTags[post.blog_id]
//                                   ? "visible"
//                                   : "hidden",
//                               }}
//                             >
//                               {post.tags && post.tags.length > 0 && (
//                                 <div className="flex flex-wrap gap-1">
//                                   {expandedTags[post.blog_id]
//                                     ? post.tags.map((tag, tagIndex) => (
//                                         <span
//                                           key={tagIndex}
//                                           className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                                         >
//                                           {tag}
//                                         </span>
//                                       ))
//                                     : post.tags
//                                         .slice(0, 4)
//                                         .map((tag, tagIndex) => (
//                                           <span
//                                             key={tagIndex}
//                                             className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                                           >
//                                             {tag}
//                                           </span>
//                                         ))}
//                                   {post.tags.length > 4 && (
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation();
//                                         toggleTagExpansion(post.blog_id);
//                                       }}
//                                       className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full hover:bg-gray-200 transition-colors"
//                                     >
//                                       {expandedTags[post.blog_id]
//                                         ? "Show less"
//                                         : `+${post.tags.length - 4}`}
//                                     </button>
//                                   )}
//                                 </div>
//                               )}
//                             </div>

//                             {/* Status and Toggle - Fixed at Bottom */}
//                             <div className="flex justify-between items-center mt-auto">
//                               <div className="flex items-center gap-2">
//                                 <span className="text-xs font-medium">
//                                   Status:
//                                 </span>
//                                 <span
//                                   className={`text-xs font-bold ${status.color}`}
//                                 >
//                                   {status.text}
//                                 </span>
//                               </div>
//                               <div className="flex items-center">
//                                 <input
//                                   type="checkbox"
//                                   id={`toggle-${post.blog_id}`}
//                                   checked={postStates[post.blog_id] || false}
//                                   onChange={() => handleToggle(post.blog_id)}
//                                   className="sr-only"
//                                 />
//                                 <label
//                                   htmlFor={`toggle-${post.blog_id}`}
//                                   className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors cursor-pointer ${
//                                     postStates[post.blog_id]
//                                       ? "bg-blue-600"
//                                       : "bg-gray-300"
//                                   }`}
//                                 >
//                                   <span
//                                     className={`inline-block w-4 h-4 transform transition-transform bg-white rounded-full ${
//                                       postStates[post.blog_id]
//                                         ? "translate-x-6"
//                                         : "translate-x-1"
//                                     }`}
//                                   />
//                                 </label>
//                               </div>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Fixed Description Hover Effect */}
//                         <div className="absolute top-full left-0 right-0 z-30 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-2 pointer-events-none group-hover:pointer-events-auto ">
//                           <div className="relative mx-2 mt-3">
//                             {/* Animated Background with Blue Theme */}
//                             <div className="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 rounded-2xl blur-sm opacity-50 animate-pulse"></div>

//                             {/* Main Description Container - Fixed Height with Scroll */}
//                             <div
//                               className="relative bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-white/30 transform transition-all duration-500 hover:scale-105"
//                               style={{ maxHeight: "300px" }}
//                             >
//                               {/* Floating Quote Icon - Blue Theme */}
//                               <div className="absolute -top-3 left-6 w-6 h-6 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
//                                 <svg
//                                   className="w-3 h-3 text-white"
//                                   fill="currentColor"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-10zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
//                                 </svg>
//                               </div>

//                               {/* Scrollable Content */}
//                               <div
//                                 className="p-5 space-y-3"
//                                 style={{
//                                   maxHeight: "280px",
//                                   overflowY: "auto",
//                                 }}
//                               >
//                                 <div className="flex items-center gap-2 mb-3">
//                                   <div className="w-1 h-8 bg-gradient-to-b from-blue-500 to-blue-600 rounded-full"></div>
//                                   <h4 className="font-bold text-gray-800 text-base bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">
//                                     Quick Preview
//                                   </h4>
//                                 </div>

//                                 {/* Scrollable Description Text */}
//                                 <div
//                                   className="text-gray-700 text-sm leading-relaxed font-medium"
//                                   dangerouslySetInnerHTML={{
//                                     __html:
//                                       post.excerpt ||
//                                       post.description ||
//                                       post.content ||
//                                       "Default text...",
//                                   }}
//                                 />

//                                 {/* Reading Time & Word Count - Blue Theme */}
//                                 <div className="flex justify-between items-center pt-3 border-t border-gray-100">
//                                   <div className="flex items-center gap-2 text-xs text-gray-500">
//                                     <svg
//                                       className="w-4 h-4 text-blue-600"
//                                       fill="none"
//                                       stroke="currentColor"
//                                       viewBox="0 0 24 24"
//                                     >
//                                       <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth={2}
//                                         d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                                       />
//                                     </svg>
//                                     <span>
//                                       ~
//                                       {(
//                                         post.content ||
//                                         post.description ||
//                                         ""
//                                       ).split(" ").length || 150}{" "}
//                                       words
//                                     </span>
//                                   </div>
//                                 </div>
//                               </div>

//                               {/* Scroll Indicator */}
//                               <div className="absolute bottom-2 right-2 text-xs text-gray-400 opacity-50">
//                                 <svg
//                                   className="w-4 h-4"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M19 14l-7 7m0 0l-7-7m7 7V3"
//                                   />
//                                 </svg>
//                               </div>

//                               {/* Decorative Corner Elements - Blue Theme */}
//                               <div className="absolute top-2 right-2 w-2 h-2 bg-blue-400 rounded-full opacity-60 animate-ping"></div>
//                               <div className="absolute bottom-2 left-2 w-1 h-1 bg-blue-500 rounded-full opacity-60 animate-ping delay-500"></div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               )}
//               {/* Empty State */}
//               {!loading && !error && displayPosts.length === 0 && (
//                 <div className="text-center py-16">
//                   <svg
//                     className="mx-auto h-12 w-12 text-gray-400"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                     />
//                   </svg>
//                   <h3 className="mt-2 text-sm font-medium text-gray-900">
//                     No blog posts
//                   </h3>
//                   <p className="mt-1 text-sm text-gray-500">
//                     Get started by creating your first blog post.
//                   </p>
//                   <div className="mt-6">
//                     <button
//                       onClick={() => setIsAddBlogOpen(true)}
//                       className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
//                     >
//                       <svg
//                         className="-ml-1 mr-2 h-5 w-5"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                       New Blog Post
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </>
//       )}
//       {/* Delete View */}
//       {currentView === "delete" && <BlogDelete onNavigate={handleNavigation} />}
//       {/* Archive View */}
//       {currentView === "archive" && (
//         <BlogArchive onNavigate={handleNavigation} />
//       )}
//       {/* Add Blog Modal */}
//       {isAddBlogOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">
//                   {isEditMode ? "Edit Blog Post" : "Add New Blog Post"}
//                 </h2>
//                 <button
//                   onClick={closeBlogPopup}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//               <form onSubmit={handleBlogSubmit} className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Title *
//                   </label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Content *
//                   </label>
//                   <RichTextEditor
//                     value={formData.content}
//                     onChange={(content) =>
//                       setFormData((prev) => ({ ...prev, content }))
//                     }
//                     placeholder="Write your blog content here..."
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Category *
//                   </label>
//                   {loadingCategories ? (
//                     <div className="flex items-center space-x-2">
//                       <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
//                       <span className="text-sm text-gray-500">
//                         Loading categories...
//                       </span>
//                     </div>
//                   ) : categoryError ? (
//                     <div className="text-red-600 text-sm">{categoryError}</div>
//                   ) : (
//                     <select
//                       name="category_id"
//                       value={formData.category_id}
//                       onChange={handleCategoryChange}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       required
//                     >
//                       <option value="">Select a category</option>
//                       {categories.map((category) => (
//                         <option
//                           key={category.category_id}
//                           value={category.category_id}
//                         >
//                           {category.category_name}
//                         </option>
//                       ))}
//                     </select>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Tags (comma-separated)
//                   </label>
//                   <input
//                     type="text"
//                     value={tagsInput}
//                     onChange={handleTagsChange}
//                     placeholder="e.g., jewelry, fashion, style"
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   {formData.tags.length > 0 && (
//                     <div className="mt-2 flex flex-wrap gap-1">
//                       {formData.tags.map((tag, index) => (
//                         <span
//                           key={index}
//                           className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                         >
//                           {tag}
//                           <button
//                             type="button"
//                             onClick={() => removeTag(index)}
//                             className="ml-1 text-blue-600 hover:text-blue-800"
//                           >
//                             ×
//                           </button>
//                         </span>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Main Image
//                   </label>
//                   <input
//                     type="file"
//                     accept="image/*"
//                     onChange={handleMainImageChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   {mainImagePreview && (
//                     <div className="mt-2">
//                       <img
//                         src={mainImagePreview}
//                         alt="Main image preview"
//                         className="w-32 h-32 object-cover rounded-md"
//                       />
//                     </div>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Status
//                   </label>
//                   <select
//                     name="status"
//                     value={formData.status}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   >
//                     <option value="draft">Draft</option>
//                     <option value="published">published</option>
//                   </select>
//                 </div>
//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={closeBlogPopup}
//                     className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
//                   >
//                     {isSubmitting
//                       ? isEditMode
//                         ? "Updating..."
//                         : "Creating..."
//                       : isEditMode
//                       ? "Update Blog"
//                       : "Create Blog"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Add Category Modal */}
//       {isAddCategoryOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-md w-full">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">Add New Category</h2>
//                 <button
//                   onClick={closeCategoryPopup}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//               <form onSubmit={handleCategorySubmit} className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Category Name *
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={categoryFormData.name}
//                     onChange={handleCategoryInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     required
//                   />
//                 </div>
//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={closeCategoryPopup}
//                     className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isSubmittingCategory}
//                     className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
//                   >
//                     {isSubmittingCategory ? "Creating..." : "Create Category"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Manage Categories Modal */}
//       {isManageCategoriesOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-md w-full max-h-[80vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">Manage Categories</h2>
//                 <button
//                   onClick={closeManageCategories}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               {loadingCategoriesList ? (
//                 <div className="flex justify-center items-center py-8">
//                   <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
//                 </div>
//               ) : (
//                 <div className="space-y-2">
//                   {categoriesList.length > 0 ? (
//                     categoriesList.map((category) => (
//                       <div
//                         key={category.category_id}
//                         className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50"
//                       >
//                         <span className="font-medium">
//                           {category.category_name}
//                         </span>
//                         <div className="flex gap-2">
//                           <button
//                             onClick={() => handleEditCategory(category)}
//                             className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
//                           >
//                             Edit
//                           </button>
//                           <button
//                             onClick={() =>
//                               handleDeleteCategory(
//                                 category.category_id,
//                                 category.category_name
//                               )
//                             }
//                             className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700"
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="text-center py-8 text-gray-500">
//                       No categories found
//                     </div>
//                   )}
//                 </div>
//               )}

//               <div className="flex justify-end pt-4">
//                 <button
//                   onClick={closeManageCategories}
//                   className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Category Modal */}
//       {isEditCategoryOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-md w-full">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">Edit Category</h2>
//                 <button
//                   onClick={closeEditCategory}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               <form onSubmit={handleCategoryUpdate} className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Category Name *
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={categoryFormData.name}
//                     onChange={handleCategoryInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     required
//                   />
//                 </div>

//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={closeEditCategory}
//                     className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isSubmittingCategory}
//                     className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
//                   >
//                     {isSubmittingCategory ? "Updating..." : "Update Category"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// export default Blog;

// import React, { useState, useEffect, useRef } from "react";
// import BlogDelete from "./BlogDelete";
// import BlogArchive from "./BlogArchive";
// import { BASE_URL, DOMAIN_URL } from "../../config";
// import axios from "axios";

// // FIXED: Enhanced Rich Text Editor Component
// const RichTextEditor = ({ value, onChange, placeholder }) => {
//   const editorRef = useRef(null);

//   useEffect(() => {
//     if (editorRef.current && value !== editorRef.current.innerHTML) {
//       editorRef.current.innerHTML = value;
//     }
//   }, [value]);

//   const handleInput = () => {
//     if (editorRef.current) {
//       onChange(editorRef.current.innerHTML);
//     }
//   };

//   const formatText = (command, value = null) => {
//     document.execCommand(command, false, value);
//     editorRef.current.focus();
//     handleInput();
//   };

//   const insertLink = () => {
//     const url = prompt("Enter URL:");
//     if (url) {
//       formatText("createLink", url);
//     }
//   };

//   return (
//     <div className="border border-gray-300 rounded-lg overflow-hidden">
//       {/* Enhanced Toolbar */}
//       <div className="flex flex-wrap gap-1 p-2 border-b border-gray-200 bg-gray-50">
//         <button
//           type="button"
//           onClick={() => formatText("bold")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 font-bold text-sm"
//           title="Bold"
//         >
//           B
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("italic")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 italic text-sm"
//           title="Italic"
//         >
//           I
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("underline")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 underline text-sm"
//           title="Underline"
//         >
//           U
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("strikeThrough")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 line-through text-sm"
//           title="Strike Through"
//         >
//           S
//         </button>

//         <div className="w-px h-6 bg-gray-300 mx-1"></div>

//         <button
//           type="button"
//           onClick={() => formatText("insertUnorderedList")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Bullet List"
//         >
//           • List
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("insertOrderedList")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Numbered List"
//         >
//           1. List
//         </button>

//         <div className="w-px h-6 bg-gray-300 mx-1"></div>

//         <button
//           type="button"
//           onClick={() => formatText("justifyLeft")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Align Left"
//         >
//           ⬅
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("justifyCenter")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Align Center"
//         >
//           ↔
//         </button>
//         <button
//           type="button"
//           onClick={() => formatText("justifyRight")}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Align Right"
//         >
//           ➡
//         </button>

//         <div className="w-px h-6 bg-gray-300 mx-1"></div>

//         <button
//           type="button"
//           onClick={insertLink}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           title="Insert Link"
//         >
//           🔗
//         </button>

//         <select
//           onChange={(e) => formatText("fontSize", e.target.value)}
//           className="px-2 py-1 border rounded hover:bg-gray-200 text-sm"
//           defaultValue="3"
//         >
//           <option value="1">Small</option>
//           <option value="3">Normal</option>
//           <option value="5">Large</option>
//           <option value="7">Huge</option>
//         </select>
//       </div>

//       {/* FIXED: Editor with proper direction and styling */}
//       <div
//         ref={editorRef}
//         contentEditable
//         onInput={handleInput}
//         className="p-3 min-h-[200px] focus:outline-none text-left"
//         style={{
//           minHeight: "200px",
//           direction: "ltr",
//           textAlign: "left",
//           unicodeBidi: "embed",
//         }}
//         data-placeholder={placeholder}
//         suppressContentEditableWarning={true}
//       />
//     </div>
//   );
// };

// const Blog = ({ dimension, fromTabs }) => {
//   // Navigation state
//   const [currentView, setCurrentView] = useState("home");
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [openPostMenus, setOpenPostMenus] = useState({});
//   const [postStates, setPostStates] = useState({});
//   const menuRef = useRef(null);

//   // Search state
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResults, setSearchResults] = useState([]);

//   // Blog form states
//   const [isAddBlogOpen, setIsAddBlogOpen] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [formData, setFormData] = useState({
//     title: "",
//     content: "",
//     main_image_url: "",
//     category_id: "",
//     tags: [],
//     status: "draft",
//     is_archived: false,
//   });

//   // Category form states
//   const [isAddCategoryOpen, setIsAddCategoryOpen] = useState(false);
//   const [isSubmittingCategory, setIsSubmittingCategory] = useState(false);
//   const [categoryFormData, setCategoryFormData] = useState({
//     name: "",
//   });

//   // Category states
//   const [categories, setCategories] = useState([]);
//   const [loadingCategories, setLoadingCategories] = useState(false);
//   const [categoryError, setCategoryError] = useState("");

//   // File handling states
//   const [mainImageFile, setMainImageFile] = useState(null);
//   const [thumbnailImageFile, setThumbnailImageFile] = useState(null);
//   const [mainImagePreview, setMainImagePreview] = useState("");
//   const [thumbnailImagePreview, setThumbnailImagePreview] = useState("");

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   const urlParams = new URLSearchParams(window.location.search);
//   const token = urlParams.get("token");
//   const [tagsInput, setTagsInput] = useState("");

//   // Blog states
//   const [blogPosts, setBlogPosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [totalBlogs, setTotalBlogs] = useState(0);

//   // Add these state variables after your existing states
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editingBlogId, setEditingBlogId] = useState(null);
//   const [editingBlogData, setEditingBlogData] = useState(null);

//   // Add these new states for category management
//   const [isManageCategoriesOpen, setIsManageCategoriesOpen] = useState(false);
//   const [editingCategory, setEditingCategory] = useState(null);
//   const [isEditCategoryOpen, setIsEditCategoryOpen] = useState(false);
//   const [categoriesList, setCategoriesList] = useState([]);
//   const [loadingCategoriesList, setLoadingCategoriesList] = useState(false);

// const [statusFilter, setStatusFilter] = useState("all");
// const [sortBy, setSortBy] = useState("newest");

//   const [previewModal, setPreviewModal] = useState(false);
// const [previewPost, setPreviewPost] = useState(null);

// const openPreviewModal = (post) => {
//   setPreviewPost(post);
//   setPreviewModal(true);
// };

// const closePreviewModal = () => {
//   setPreviewModal(false);
//   setPreviewPost(null);
// };
//   // FIXED: Fetch blogs function with proper loading check
//   const fetchMyBlogs = async (page = 1, limit = itemsPerPage) => {
//     // Prevent multiple simultaneous calls
//     if (loading) return;

//     setLoading(true);
//     setError("");

//     console.log("Fetching blogs with:", {
//       page,
//       limit,
//       token: token ? "exists" : "missing",
//     });

//     try {
//       const response = await axios.get(`${BASE_URL}/blogs/user/my-blogs`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         params: {
//           page,
//           limit,
//         },
//       });

//       console.log("Blog API Response:", response.data);

//       if (response.data && response.data.data) {
//         // Filter out archived blogs from the main view
//         const activeBlogs = response.data.data.filter((blog) => {
//           // Handle both boolean and string values for is_archived
//           const isArchived =
//             blog.is_archived === true ||
//             blog.is_archived === "true" ||
//             blog.is_archived === 1;
//           return !isArchived;
//         });

//         console.log("Original blogs count:", response.data.data.length);
//         console.log("Active blogs count:", activeBlogs.length);
//         console.log(
//           "Filtered out archived blogs:",
//           response.data.data.filter(
//             (blog) =>
//               blog.is_archived === true ||
//               blog.is_archived === "true" ||
//               blog.is_archived === 1
//           )
//         );

        
//                 setTotalBlogs(response.data.total || response.data.data.length);
//         setBlogPosts(activeBlogs);
// setTotalBlogs(response.data.total || response.data.data.length);

// // FIX: Sync toggle status with real blog status
// const statusMap = {};
// activeBlogs.forEach((post) => {
//   statusMap[post.blog_id] = post.status === "published";
// });
// setPostStates(statusMap);

//       }
//     } catch (error) {
//       console.error("Error fetching blogs:", error);
//       console.error("Error response:", error.response?.data);
//       setError("Failed to load blogs");
//       setBlogPosts([]);
//     } finally {
//       setLoading(false);
//     }
//   };
//   // Add this state at the top of your component
//   const [expandedTags, setExpandedTags] = useState({});
//   // Add this function to handle tag expansion
//   const toggleTagExpansion = (postId) => {
//     setExpandedTags((prev) => ({
//       ...prev,
//       [postId]: !prev[postId],
//     }));
//   };

//   // FIXED: Function to fetch categories
//   const fetchCategories = async () => {
//     setLoadingCategories(true);
//     setCategoryError("");

//     try {
//       const response = await axios.get(`${BASE_URL}/blogs/categories`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (
//         response.data &&
//         response.data.data &&
//         response.data.data.length > 0
//       ) {
//         setCategories(response.data.data);
//       } else {
//         setCategories([]);
//         setCategoryError(
//           "No categories found. Please create a category first."
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//       setCategoryError("Failed to load categories");
//       setCategories([]);
//     } finally {
//       setLoadingCategories(false);
//     }
//   };

//   // FIXED: Function to create category
//   const createCategory = async (categoryData) => {
//     setIsSubmittingCategory(true);

//     try {
//       const response = await axios.post(
//         ` ${BASE_URL}/blogs/categories`,
//         {
//           name: categoryData.name,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.status === 201) {
//         setIsAddCategoryOpen(false);
//         setCategoryFormData({ name: "" });
//         await fetchCategories();
//         alert("Category created successfully!");
//         return response.data;
//       }
//     } catch (error) {
//       console.error("Error creating category:", error);
//       if (error.response) {
//         alert(
//           `Error: ${error.response.data.message || "Failed to create category"}`
//         );
//       } else {
//         alert("Error creating category");
//       }
//     } finally {
//       setIsSubmittingCategory(false);
//     }
//   };
//   // Fetch all categories for management
//   const fetchCategoriesForManagement = async () => {
//     setLoadingCategoriesList(true);
//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await fetch(
//         `${BASE_URL}/blogs/categories?page=1&limit=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         setCategoriesList(result.data || []);
//       }
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//     } finally {
//       setLoadingCategoriesList(false);
//     }
//   };

//   // Handle edit category
//   const handleEditCategory = (category) => {
//     setEditingCategory(category);
//     setCategoryFormData({ name: category.category_name });
//     setIsEditCategoryOpen(true);
//     setIsManageCategoriesOpen(false);
//   };

//   // Handle category update
//   const handleCategoryUpdate = async (e) => {
//     e.preventDefault();
//     setIsSubmittingCategory(true);

//     try {
//       const token = localStorage.getItem("authToken");
//       const response = await fetch(
//         `${BASE_URL}/blogs/categories/${editingCategory.category_id}`,
//         {
//           method: "PATCH",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ name: categoryFormData.name }),
//         }
//       );

//       if (response.ok) {
//         const result = await response.json();
//         alert(result.message || "Category updated successfully");
//         setIsEditCategoryOpen(false);
//         setEditingCategory(null);
//         setCategoryFormData({ name: "" });
//         fetchCategories(); // Refresh dropdown
//         fetchCategoriesForManagement(); // Refresh management list
//       } else {
//         const error = await response.json();
//         alert(error.message || "Failed to update category");
//       }
//     } catch (error) {
//       console.error("Error updating category:", error);
//       alert("Failed to update category");
//     } finally {
//       setIsSubmittingCategory(false);
//     }
//   };

//   // Handle delete category
//   const handleDeleteCategory = async (categoryId, categoryName) => {
//     if (
//       window.confirm(
//         `Are you sure you want to delete "${categoryName}"? This action cannot be undone.`
//       )
//     ) {
//       try {
//         const token = localStorage.getItem("authToken");
//         const response = await fetch(
//           `${BASE_URL}/blogs/categories/${categoryId}`,
//           {
//             method: "DELETE",
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (response.ok) {
//           const result = await response.json();
//           alert(result.message || "Category deleted successfully");
//           fetchCategories(); // Refresh dropdown
//           fetchCategoriesForManagement(); // Refresh management list
//         } else {
//           const error = await response.json();
//           alert(error.message || "Failed to delete category");
//         }
//       } catch (error) {
//         console.error("Error deleting category:", error);
//         alert("Failed to delete category");
//       }
//     }
//   };
// // Add these helper functions after your existing state declarations
// const formatDate = (dateString) => {
//   if (!dateString) return "Unknown date";
  
//   try {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   } catch (error) {
//     return "Invalid date";
//   }
// };

// const stripHtml = (html) => {
//   if (!html) return "";
  
//   try {
//     const temp = document.createElement("div");
//     temp.innerHTML = html;
//     return temp.textContent || temp.innerText || "";
//   } catch (error) {
//     return "";
//   }
// };
//   // Open category management modal
//   const openManageCategories = () => {
//     setIsManageCategoriesOpen(true);
//     fetchCategoriesForManagement();
//   };

//   // Close category management modal
//   const closeManageCategories = () => {
//     setIsManageCategoriesOpen(false);
//     setCategoriesList([]);
//   };

//   // Close edit category modal
//   const closeEditCategory = () => {
//     setIsEditCategoryOpen(false);
//     setEditingCategory(null);
//     setCategoryFormData({ name: "" });
//   };
//   // FIXED: Search functionality with debouncing
//   useEffect(() => {
//     const delayedSearch = setTimeout(() => {
//       if (searchTerm.trim()) {
//         const filtered = blogPosts.filter(
//           (post) =>
//             post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (post.category?.category_name &&
//               post.category.category_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase()))
//         );
//         setSearchResults(filtered);
//       } else {
//         setSearchResults([]);
//       }
//     }, 300);

//     return () => clearTimeout(delayedSearch);
//   }, [searchTerm, blogPosts]);

//   // FIXED: Fetch blogs when page changes - THIS IS THE KEY FIX
//   useEffect(() => {
//     if (currentView === "home") {
//       fetchMyBlogs(currentPage, itemsPerPage);
//     }
//   }, [currentPage, currentView, token]);

//   // Fetch categories when add blog modal opens
//   useEffect(() => {
//     if (isAddBlogOpen) {
//       fetchCategories();
//     }
//   }, [isAddBlogOpen]);

// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (!event.target.closest(".post-menu")) {
//       setOpenPostMenus({});
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);
//   return () => {
//     document.removeEventListener("mousedown", handleClickOutside);
//   };
// }, []);

//   // Reset pagination when view changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [currentView]);

//   // Navigation handler
//   const handleNavigation = (view) => {
//     if (view !== currentView) {
//       setIsAnimating(true);
//       setIsMenuOpen(false);
//       setTimeout(() => {
//         setCurrentView(view);
//         setIsAnimating(false);
//       }, 150);
//     } else {
//       setIsMenuOpen(false);
//     }
//   };

//   // Handle post menu toggle
//   const togglePostMenu = (postId) => {
//     setOpenPostMenus((prev) => ({
//       ...prev,
//       [postId]: !prev[postId],
//     }));
//   };

//   // // Handle post actions
//   // const handlePostAction = (action, postId) => {
//   //   console.log(`${action} post:`, postId);
//   //   setOpenPostMenus({});
//   // };
//   // Update the handlePostAction function
//   // Replace your handlePostAction function with this:
//   const handlePostAction = async (action, postId) => {
//     console.log("handlePostAction called:", action, postId); // Debug log
//     setOpenPostMenus({});
//     if (action === "edit") {
//       handleEditBlog(postId);
//       return;
//     }
//     if (action === "delete") {
//       try {
//         // Use the token that's already available in the component scope
//         console.log("Token found:", token ? "YES" : "NO"); // Debug log
//         console.log("Attempting to soft delete blog:", postId); // Debug log

//         const response = await fetch(`${BASE_URL}/blogs/${postId}`, {
//           method: "DELETE",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`, // Use the token from component scope
//           },
//         });

//         console.log("Delete response status:", response.status); // Debug log

//         if (response.ok) {
//           const result = await response.json();
//           console.log("Blog soft deleted successfully:", result);

//           // Refresh the blog list
//           await fetchMyBlogs(currentPage, itemsPerPage);

//           alert("Blog post moved to trash successfully");
//         } else {
//           const errorData = await response.json();
//           console.error("Failed to delete blog post:", errorData);
//           alert("Failed to delete blog post: " + errorData.message);
//         }
//       } catch (error) {
//         console.error("Error deleting blog post:", error);
//         alert("Error deleting blog post: " + error.message);
//       }
//     }
//     // Handle archive action
//     if (action === "archive") {
//       // Show confirmation dialog
//       const confirmed = window.confirm(
//         "Are you sure you want to archive this blog post?"
//       );

//       if (!confirmed) {
//         return;
//       }
//       try {
//         console.log("Token found:", token ? "YES" : "NO");
//         console.log("Attempting to archive blog:", postId);

//         const response = await fetch(`${BASE_URL}/blogs/${postId}/archive`, {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         console.log("Archive response status:", response.status);
//         if (response.ok) {
//           const result = await response.json();
//           console.log("Blog archived successfully:", result);

//           // Refresh the blog list
//           await fetchMyBlogs(currentPage, itemsPerPage);

//           alert("Blog post archived successfully!");
//         } else {
//           const errorData = await response.json();
//           console.error("Failed to archive blog post:", errorData);
//           alert("Failed to archive blog post: " + errorData.message);
//         }
//       } catch (error) {
//         console.error("Error archiving blog post:", error);
//         alert("Error archiving blog post: " + error.message);
//       }
//     }
//   };

//   // Add this function after your handlePostAction function
//   const handleEditBlog = async (blogId) => {
//     console.log("Editing blog:", blogId);

//     try {
//       // Find the blog data from current posts
//       const blogToEdit = currentPosts.find((post) => post.blog_id === blogId);

//       if (!blogToEdit) {
//         alert("Blog not found");
//         return;
//       }

//       console.log("Blog to edit:", blogToEdit);

//       // Set form data with existing blog data
//       setFormData({
//         title: blogToEdit.title || "",
//         content: blogToEdit.content || "",
//         main_image_url: blogToEdit.main_image_url || "",
//         category_id: blogToEdit.category_id || "",
//         tags: blogToEdit.tags || [],
//         status: blogToEdit.status || "draft",
//         is_archived: blogToEdit.is_archived || false,
//       });

//       // Set tags input for display
//       setTagsInput(blogToEdit.tags ? blogToEdit.tags.join(", ") : "");

//       // Set edit mode
//       setIsEditMode(true);
//       setEditingBlogId(blogId);
//       setEditingBlogData(blogToEdit);

//       // Set main image preview if exists
//       if (blogToEdit.main_image_url) {
//         setMainImagePreview(blogToEdit.main_image_url);
//       }

//       // Open the blog form modal
//       setIsAddBlogOpen(true);

//       // Fetch categories for the form
//       fetchCategories();
//     } catch (error) {
//       console.error("Error preparing blog for edit:", error);
//       alert("Error loading blog for editing");
//     }
//   };

//   const handleToggle = async (blogId) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const currentPost = displayPosts.find((post) => post.blog_id === blogId);
//       const currentStatus = currentPost?.status || "draft";
//       const newStatus = currentStatus === "draft" ? "published" : "draft";

//       const response = await fetch(
//         `${BASE_URL}/blogs/${blogId}/toggle-status`,
//         {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ status: newStatus }),
//         }
//       );

//       if (response.ok) {
//         // Update local state
//         setPostStates((prev) => ({
//           ...prev,
//           [blogId]: newStatus === "published",
//         }));

//         // Show confirmation message
//         const message =
//           newStatus === "published"
//             ? "Blog post published successfully!"
//             : "Blog post saved as draft!";

//         alert(message); // Or use toast notification

//         // Refresh the blog list
//         fetchMyBlogs(currentPage, itemsPerPage);
//       }
//     } catch (error) {
//       console.error("Error updating blog status:", error);
//       alert("Failed to update blog status");
//     }
//   };
//   // Get status text and color
//   const getStatusDisplay = (postId) => {
//     const isOn = postStates[postId];
//     return {
//       text: isOn ? "Published" : "Draft",
//       color: isOn ? "text-green-600" : "text-gray-400",
//     };
//   };

//   // FIXED: Get display posts for server-side pagination
//   const getDisplayPosts = () => {
//     if (searchTerm.trim()) {
//       return blogPosts.filter(
//         (post) =>
//           (post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (post.category?.category_name &&
//               post.category.category_name
//                 .toLowerCase()
//                 .includes(searchTerm.toLowerCase()))) &&
//           (post.status === "draft" || post.status === "published")
//       );
//     }
//     return blogPosts.filter(
//       (post) => post.status === "draft" || post.status === "published"
//     );
//   };

//   const displayPosts = getDisplayPosts();

//   // FIXED: Server-side pagination - DON'T slice the data again
//   const currentPosts = displayPosts; // Use all posts from current page

//   // FIXED: Calculate total pages from server response
//   const totalPages = Math.max(1, Math.ceil(totalBlogs / itemsPerPage));

//   // FIXED: Pagination handlers
//   const goToPage = (page) => {
//     setCurrentPage(page);
//     // fetchMyBlogs will be called automatically by useEffect
//   };

//   const goToPrevious = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const goToNext = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   // Color gradients for fallback
//   const gradients = [
//     "from-pink-100 to-pink-200",
//     "from-orange-100 to-orange-200",
//     "from-green-100 to-green-200",
//     "from-purple-100 to-purple-200",
//     "from-blue-100 to-blue-200",
//     "from-yellow-100 to-yellow-200",
//   ];

//   // Category colors for badges
//   const getCategoryColor = (category) => {
//     const colors = {
//       Rings: "bg-purple-50 text-purple-600",
//       Bracelets: "bg-blue-50 text-blue-600",
//       Bangles: "bg-green-50 text-green-600",
//       Necklaces: "bg-pink-50 text-pink-600",
//       gold: "bg-yellow-50 text-yellow-600",
//       Chains: "bg-indigo-50 text-indigo-600",
//       Pendants: "bg-red-50 text-red-600",
//     };
//     return colors[category] || "bg-yellow-50 text-yellow-600";
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   // Handle category form input changes
//   const handleCategoryInputChange = (e) => {
//     const { name, value } = e.target;
//     setCategoryFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Handle category selection
//   const handleCategoryChange = (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       category_id: e.target.value,
//     }));
//   };

//   // Handle tags input
//   const handleTagsChange = (e) => {
//     const inputValue = e.target.value;
//     setTagsInput(inputValue);

//     const tags = inputValue
//       .split(",")
//       .map((tag) => tag.trim())
//       .filter((tag) => tag)
//       .filter((tag, index, arr) => arr.indexOf(tag) === index);

//     setFormData((prev) => ({
//       ...prev,
//       tags: tags,
//     }));
//   };

//   // Remove individual tag
//   const removeTag = (indexToRemove) => {
//     const newTags = formData.tags.filter((_, index) => index !== indexToRemove);
//     setFormData((prev) => ({
//       ...prev,
//       tags: newTags,
//     }));
//     setTagsInput(newTags.join(", "));
//   };

//   // FIXED: Handle search input
//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);

//     // If search is cleared, fetch fresh data
//     if (!e.target.value.trim()) {
//       fetchMyBlogs(1, itemsPerPage);
//     }
//   };

//   // Handle main image file selection
//   const handleMainImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
//       if (!allowedTypes.includes(file.type)) {
//         alert("Please select a valid image file (JPEG, PNG, or WebP)");
//         return;
//       }

//       if (file.size > 10 * 1024 * 1024) {
//         alert("File size must be less than 10MB");
//         return;
//       }

//       setMainImageFile(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setMainImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Handle thumbnail image file selection
//   const handleThumbnailImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setThumbnailImageFile(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setThumbnailImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Update your existing closeBlogPopup function
//   const closeBlogPopup = () => {
//     setIsAddBlogOpen(false);

//     // Reset form data
//     setFormData({
//       title: "",
//       content: "",
//       main_image_url: "",
//       category_id: "",
//       tags: [],
//       status: "draft",
//       is_archived: false,
//     });

//     // Reset all states
//     setTagsInput("");
//     setMainImageFile(null);
//     setThumbnailImageFile(null);
//     setMainImagePreview("");
//     setThumbnailImagePreview("");
//     setCategoryError("");
//     setCategories([]);

//     // Reset edit mode
//     setIsEditMode(false);
//     setEditingBlogId(null);
//     setEditingBlogData(null);
//   };

//   // Close category popup
//   const closeCategoryPopup = () => {
//     setIsAddCategoryOpen(false);
//     setCategoryFormData({
//       name: "",
//     });
//   };
// const cleanTags = (tagsInput) => {
//   if (!tagsInput) return [];

//   if (Array.isArray(tagsInput)) {
//     return tagsInput.map(tag => tag.trim()).filter(Boolean);
//   }

//   return tagsInput
//     .split(',')
//     .map(tag => tag.trim())
//     .filter(tag => tag.length > 0);
// };

//   // const handleBlogSubmit = async (e) => {
//   //   e.preventDefault();

//   //   if (!formData.title.trim()) {
//   //     alert("Please enter a title");
//   //     return;
//   //   }

//   //   if (!formData.content.trim()) {
//   //     alert("Please enter content");
//   //     return;
//   //   }

//   //   if (!formData.category_id) {
//   //     alert("Please select a category");
//   //     return;
//   //   }

//   //   setIsSubmitting(true);

//   //   try {
//   //     const cleanedTags = cleanTags(formData.tags);
//   //     console.log("Cleaned tags:", cleanedTags);

//   //     const hasImages = mainImageFile || thumbnailImageFile;

//   //     if (!hasImages) {
//   //       // No images - use JSON
//   //       const jsonData = {
//   //         title: formData.title,
//   //         content: formData.content,
//   //         category_id: formData.category_id,
//   //         tags: cleanedTags.length > 0 ? cleanedTags : undefined,
//   //         status: formData.status,
//   //         is_archived: false, // FIXED: Always false for new blogs
//   //       };

//   //       console.log("Sending JSON data:", jsonData);

//   //       // Choose endpoint based on edit mode
//   //       const url = isEditMode
//   //         ? `${BASE_URL}/blogs/${editingBlogId}`
//   //         : `${BASE_URL}/blogs`;
//   //       const method = isEditMode ? "PATCH" : "POST";

//   //       const response = await axios({
//   //         method,
//   //         url,
//   //         data: jsonData,
//   //         headers: {
//   //           Authorization: `Bearer ${token}`,
//   //           "Content-Type": "application/json",
//   //         },
//   //       });

//   //       if (response.status === 200 || response.status === 201) {
//   //         closeBlogPopup();
//   //         alert(
//   //           isEditMode
//   //             ? "Blog updated successfully!"
//   //             : "Blog created successfully!"
//   //         );
//   //         fetchMyBlogs(currentPage, itemsPerPage);
//   //       }
//   //     } else {
//   //       // With images - use FormData
//   //       const submitData = new FormData();
//   //       submitData.append("title", formData.title);
//   //       submitData.append("content", formData.content);
//   //       submitData.append("category_id", formData.category_id);
//   //       submitData.append("status", formData.status);
//   //       submitData.append("is_archived", "false"); // FIXED: Always false for new blogs

//   //       if (cleanedTags.length > 0) {
//   //         cleanedTags.forEach((tag) => {
//   //           submitData.append("tags", tag);
//   //         });
//   //       }

//   //       if (mainImageFile) {
//   //         submitData.append("main_image", mainImageFile);
//   //       }

//   //       if (thumbnailImageFile) {
//   //         submitData.append("thumbnail_image", thumbnailImageFile);
//   //       }

//   //       console.log("Sending FormData with tags:", cleanedTags);

//   //       // Choose endpoint based on edit mode
//   //       const url = isEditMode
//   //         ? `${BASE_URL}/blogs/${editingBlogId}`
//   //         : `${BASE_URL}/blogs`;
//   //       const method = isEditMode ? "PATCH" : "POST";

//   //       const response = await axios({
//   //         method,
//   //         url,
//   //         data: submitData,
//   //         headers: {
//   //           Authorization: `Bearer ${token}`,
//   //           "Content-Type": "multipart/form-data",
//   //         },
//   //       });

//   //       if (response.status === 200 || response.status === 201) {
//   //         closeBlogPopup();
//   //         alert(
//   //           isEditMode
//   //             ? "Blog updated successfully!"
//   //             : "Blog created successfully!"
//   //         );
//   //         fetchMyBlogs(currentPage, itemsPerPage);
//   //       }
//   //     }
//   //   } catch (error) {
//   //     console.error("Error with blog operation:", error);
//   //     if (error.response) {
//   //       console.error("Full response data:", error.response.data);
//   //       if (error.response.data && error.response.data.message) {
//   //         console.error(
//   //           "Detailed error messages:",
//   //           error.response.data.message
//   //         );
//   //       }
//   //       alert(
//   //         `Error: ${JSON.stringify(
//   //           error.response.data.message || "Operation failed"
//   //         )}`
//   //       );
//   //     } else {
//   //       alert("Error with blog operation");
//   //     }
//   //   } finally {
//   //     setIsSubmitting(false);
//   //   }
//   // };

// const handleBlogSubmit = async (e) => {
//   e.preventDefault();

//   if (!formData.title.trim()) {
//     alert("Please enter a title");
//     return;
//   }

//   if (!formData.content.trim()) {
//     alert("Please enter content");
//     return;
//   }

//   if (!formData.category_id) {
//     alert("Please select a category");
//     return;
//   }

//   setIsSubmitting(true);

//   try {
//     const cleanedTags = cleanTags(formData.tags);
//     console.log("Cleaned tags:", cleanedTags);

//     const hasImages = mainImageFile || thumbnailImageFile;

//     if (!hasImages) {
//       // No images - use JSON
//       const jsonData = {
//         title: formData.title,
//         content: formData.content,
//         category_id: formData.category_id,
//         tags: cleanedTags.length > 0 ? cleanedTags : undefined,
//         status: formData.status,
//         is_archived: false, // CRITICAL: Always false to prevent archiving
//       };

//       console.log("Sending JSON data:", jsonData);

//       // Choose endpoint based on edit mode
//       const url = isEditMode
//         ? `${BASE_URL}/blogs/${editingBlogId}`
//         : `${BASE_URL}/blogs`;
//       const method = isEditMode ? "PATCH" : "POST";

//       const response = await axios({
//         method,
//         url,
//         data: jsonData,
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (response.status === 200 || response.status === 201) {
//         closeBlogPopup();
//         alert(
//           isEditMode
//             ? "Blog updated successfully!"
//             : "Blog created successfully!"
//         );
//         fetchMyBlogs(currentPage, itemsPerPage);
//       }
//     } else {
//       // With images - use FormData
//       const submitData = new FormData();
//       submitData.append("title", formData.title);
//       submitData.append("content", formData.content);
//       submitData.append("category_id", formData.category_id);
//       submitData.append("status", formData.status);
      
//       // CRITICAL FIX: Explicitly set is_archived to false
//       submitData.append("is_archived", "false");

//       // IMPORTANT: For edit mode, send tags as JSON string
//       if (cleanedTags.length > 0) {
//         if (isEditMode) {
//           submitData.append("tags", JSON.stringify(cleanedTags));
//         } else {
//           cleanedTags.forEach((tag) => {
//             submitData.append("tags", tag);
//           });
//         }
//       }

//       if (mainImageFile) {
//         console.log("Adding main image to FormData:", mainImageFile.name);
//         submitData.append("main_image", mainImageFile);
//       }

//       if (thumbnailImageFile) {
//         submitData.append("thumbnail_image", thumbnailImageFile);
//       }

//       console.log("Sending FormData. Edit mode:", isEditMode);
//       console.log("Has main image:", !!mainImageFile);
//       console.log("is_archived value:", submitData.get("is_archived")); // Debug log

//       // CRITICAL FIX: Use different endpoints for edit vs create
//       let url, method;
//       if (isEditMode) {
//         // For editing with images, use the /with-image endpoint
//         url = `${BASE_URL}/blogs/${editingBlogId}/with-image`;
//         method = "PATCH";
//       } else {
//         // For creating, use the regular endpoint
//         url = `${BASE_URL}/blogs`;
//         method = "POST";
//       }

//       console.log("Using endpoint:", url);

//       const response = await axios({
//         method,
//         url,
//         data: submitData,
//         headers: {
//           Authorization: `Bearer ${token}`,
//           // Don't set Content-Type - let axios handle it for FormData
//         },
//       });

//       console.log("Response status:", response.status);
//       console.log("Response data:", response.data);
//       console.log("Response is_archived:", response.data?.is_archived); // Debug log

//       if (response.status === 200 || response.status === 201) {
//         // Update local state with the server response
//         if (isEditMode && response.data) {
//           setBlogPosts(prevPosts => 
//             prevPosts.map(post => 
//               post.blog_id === editingBlogId 
//                 ? { ...post, ...response.data, is_archived: false } // Force is_archived to false
//                 : post
//             )
//           );
//         }

//         closeBlogPopup();
//         alert(
//           isEditMode
//             ? "Blog updated successfully!"
//             : "Blog created successfully!"
//         );
//         fetchMyBlogs(currentPage, itemsPerPage);
//       }
//     }
//   } catch (error) {
//     console.error("Error with blog operation:", error);
//     if (error.response) {
//       console.error("Full response data:", error.response.data);
//       if (error.response.data && error.response.data.message) {
//         console.error(
//           "Detailed error messages:",
//           error.response.data.message
//         );
//       }
//       alert(
//         `Error: ${JSON.stringify(
//           error.response.data.message || "Operation failed"
//         )}`
//       );
//     } else {
//       alert("Error with blog operation");
//     }
//   } finally {
//     setIsSubmitting(false);
//   }
// };
//   // Submit category form
//   const handleCategorySubmit = async (e) => {
//     e.preventDefault();

//     if (!categoryFormData.name.trim()) {
//       alert("Please enter a category name");
//       return;
//     }

//     await createCategory(categoryFormData);
//   };
// const getFilteredPosts = () => {
//   if (!displayPosts || displayPosts.length === 0) {
//     return [];
//   }

//   let filtered = [...displayPosts];

//   // Filter by status only
//   if (statusFilter !== "all") {
//     filtered = filtered.filter(post => {
//       if (statusFilter === "published") {
//         return post.status === "published";
//       } else if (statusFilter === "draft") {
//         return post.status === "draft";
//       }
//       return true;
//     });
//   }

//   // Sort posts
//   filtered.sort((a, b) => {
//     const dateA = new Date(a.created_at);
//     const dateB = new Date(b.created_at);

//     if (sortBy === "newest") {
//       return dateB - dateA;
//     } else if (sortBy === "oldest") {
//       return dateA - dateB;
//     } else if (sortBy === "title") {
//       return a.title.localeCompare(b.title);
//     }
//     return 0;
//   });

//   return filtered;
// };
//   const filteredPosts = getFilteredPosts();
//   return (
//     <div className=" flex flex-col bg-gray-50">
//       {/* Only show header and main content when on home page */}
//       {currentView === "home" && (
//         <>
//           {/* Header */}
//           <div className="flex-shrink-0 bg-white shadow-sm border-b">
//             <div className="px-6 py-4">
//               <div className="flex items-center justify-between">
//                 {/* Tab Navigation */}
// <div className="flex bg-gray-100 rounded-lg p-1">
//   <button
//     onClick={() => handleNavigation("home")}
//     className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
//       currentView === "home"
//         ? "bg-white text-blue-600 shadow-sm"
//         : "text-gray-600 hover:text-gray-800"
//     }`}
//   >
//     <svg
//       className="w-4 h-4 inline mr-2"
//       fill="none"
//       stroke="currentColor"
//       viewBox="0 0 24 24"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
//       />
//     </svg>
//     Home
//   </button>

//   <button
//     onClick={() => handleNavigation("delete")}
//     className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
//       currentView === "delete"
//         ? "bg-white text-red-600 shadow-sm"
//         : "text-gray-600 hover:text-gray-800"
//     }`}
//   >
//     <svg
//       className="w-4 h-4 inline mr-2"
//       fill="none"
//       stroke="currentColor"
//       viewBox="0 0 24 24"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//       />
//     </svg>
//     Deleted
//   </button>

//   <button
//     onClick={() => handleNavigation("archive")}
//     className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
//       currentView === "archive"
//         ? "bg-white text-yellow-600 shadow-sm"
//         : "text-gray-600 hover:text-gray-800"
//     }`}
//   >
//     <svg
//       className="w-4 h-4 inline mr-2"
//       fill="none"
//       stroke="currentColor"
//       viewBox="0 0 24 24"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h14a2 2 0 002-2V8m-9 4h4"
//       />
//     </svg>
//     Archive
//   </button>
// </div>
//                 {/* Action Buttons */}
//                 <div className="flex gap-4">
//                   <button
//                     onClick={() => setIsAddBlogOpen(true)}
//                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     Add Blog
//                   </button>
//                   <button
//                     onClick={() => setIsAddCategoryOpen(true)}
//                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
//                   >
//                     Add Category
//                   </button>
//                   <button
//                     onClick={openManageCategories}
//                     className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
//                   >
//                     Manage Categories
//                   </button>

//                   {/* Search Bar */}
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Search..."
//                       value={searchTerm}
//                       onChange={handleSearchChange}
//                       className="pl-4 pr-10 py-2 border border-gray-300 rounded w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                     <button className="absolute right-2 top-1/2 transform -translate-y-1/2">
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                         />
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Main Content */}
//           <div className="flex-1 overflow-auto">
//             <div
//               className={`px-6 py-6 transition-all duration-300 ${
//                 isAnimating
//                   ? "opacity-50 transform translate-x-4"
//                   : "opacity-100 transform translate-x-0"
//               }`}
//             >
//               <div className="mb-6">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-4">
//                     <h2 className="text-xl font-semibold text-gray-800">
//                       Blog Posts
//                     </h2>
//                     {!loading && displayPosts.length > 0 && (
//                       <span className="text-sm text-gray-600">
//                         Page {currentPage} of {totalPages} ({totalBlogs} total
//                         blogs)
//                       </span>
//                     )}
//                   </div>

              
//                 </div>
//               </div>
//               {/* Loading State */}
//               {loading && (
//                 <div className="flex justify-center items-center py-16">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//                 </div>
//               )}
//               {/* Error State */}
//               {error && (
//                 <div className="text-center py-16">
//                   <p className="text-red-600 text-lg">{error}</p>
//                   <button
//                     onClick={() => fetchMyBlogs(currentPage, itemsPerPage)}
//                     className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//                   >
//                     Try Again
//                   </button>
//                 </div>
//               )}
//               {/* Blog Posts Grid */}
//               {/* Blog Posts Grid */}
//               {!loading && !error && displayPosts.length > 0 && (
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
//                   {displayPosts.map((post, index) => {
//                     const status = getStatusDisplay(post.blog_id);
//                     return (
//                       <div
//                         key={post.blog_id}
//                         className="group relative"
//                         style={{ minHeight: "420px" }} // Fixed height for consistency
//                       >
//                         {/* Main Card - Fixed Structure */}
//                         <div
//                           className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer relative"
//                           style={{
//                             minHeight: "530px",
//                             height: expandedTags[post.blog_id]
//                               ? "auto"
//                               : "420px",
//                           }}
//                         >
//                           {/* Post Menu Button */}
//                           <div className="absolute top-3 right-3 z-10">
//                        <button
//   onClick={() => togglePostMenu(post.blog_id)}
//   className="p-2 bg-white/95  hover:bg-gray-100 rounded-full transition-colors"
// >
//   <svg
//     className="w-5 h-5 text-gray-500"
//     fill="none"
//     stroke="currentColor"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth={2}
//       d="M12 5v.01M12 12v.01M12 19v.01"
//     />
//   </svg>
// </button>

//                             {/* Dropdown Menu */}
//                             {openPostMenus[post.blog_id] && (
//                               <div className="absolute top-full right-0 mt-2 w-32 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden post-menu">
//                                 <div className="py-2">
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                       handlePostAction("edit", post.blog_id);
//                                     }}
//                                     className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-blue-600"
//                                   >
//                                     Edit
//                                   </button>
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                       handlePostAction("archive", post.blog_id);
//                                     }}
//                                     className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-yellow-600"
//                                   >
//                                     Archive
//                                   </button>
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                       handlePostAction("delete", post.blog_id);
//                                     }}
//                                     className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-red-600"
//                                   >
//                                     Delete
//                                   </button>
//                                 </div>
//                               </div>
//                             )}
//                           </div>

//                 {/* Image - Fixed Height */}
// <div className="relative group" style={{ height: "300px" }}>
//   {post.main_image_url ? (
//     <img
//       src={post.main_image_url}
//       alt={post.title}
//       className="w-full h-full object-cover"
//     />
//   ) : (
//     <div
//       className={`w-full h-full bg-gradient-to-br ${
//         gradients[index % gradients.length]
//       } flex items-center justify-center`}
//     >
//       <span className="text-gray-500 text-lg font-medium">
//         No Image
//       </span>
//     </div>
//   )}
//   {/* Eye Icon Overlay - positioned below kebab menu */}
// <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
//   <button
//     onClick={(e) => {
//       e.stopPropagation();
//       openPreviewModal(post);
//     }}
//     className="bg-white/95 p-2 rounded-full hover:bg-gray-100 transition-colors mt-12 shadow-md"
//     style={{ marginTop: '50px' }} // Position below kebab menu
//   >
//     <svg
//       className="w-5 h-5 text-gray-700"
//       fill="none"
//       stroke="currentColor"
//       viewBox="0 0 24 24"
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//       />
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeWidth={2}
//         d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//       />
//     </svg>
//   </button>
// </div>
// </div>

//                           {/* Content - Fixed Layout */}
//                           <div
//                             className="p-4 flex flex-col"
//                             style={{
//                               minHeight: "220px",
//                               height: expandedTags[post.blog_id]
//                                 ? "auto"
//                                 : "220px",
//                             }}
//                           >
//                             <div className="flex justify-between items-start text-xs text-gray-600 mb-2">
//                               <span
//                                 className={`px-2 py-1 rounded text-xs ${getCategoryColor(
//                                   post.category?.category_name
//                                 )}`}
//                               >
//                                 {post.category?.category_name ||
//                                   "Uncategorized"}
//                               </span>
//                               <span>
//                                 {new Date(post.created_at).toLocaleDateString()}
//                               </span>
//                             </div>

//                             <h3
//                               className="font-semibold text-gray-800 mb-3 text-sm text-center line-clamp-2"
//                               style={{ height: "40px" }}
//                             >
//                               {post.title}
//                             </h3>
//                             {/* Tags - Dynamic Height Container */}
//                             <div
//                               className="mb-3"
//                               style={{
//                                 minHeight: "60px",
//                                 height: expandedTags[post.blog_id]
//                                   ? "auto"
//                                   : "60px",
//                                 overflow: expandedTags[post.blog_id]
//                                   ? "visible"
//                                   : "hidden",
//                               }}
//                             >
//                               {post.tags && post.tags.length > 0 && (
//                                 <div className="flex flex-wrap gap-1">
//                                   {expandedTags[post.blog_id]
//                                     ? post.tags.map((tag, tagIndex) => (
//                                         <span
//                                           key={tagIndex}
//                                           className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                                         >
//                                           {tag}
//                                         </span>
//                                       ))
//                                     : post.tags
//                                         .slice(0, 4)
//                                         .map((tag, tagIndex) => (
//                                           <span
//                                             key={tagIndex}
//                                             className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                                           >
//                                             {tag}
//                                           </span>
//                                         ))}
//                                   {post.tags.length > 4 && (
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation();
//                                         toggleTagExpansion(post.blog_id);
//                                       }}
//                                       className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full hover:bg-gray-200 transition-colors"
//                                     >
//                                       {expandedTags[post.blog_id]
//                                         ? "Show less"
//                                         : `+${post.tags.length - 4}`}
//                                     </button>
//                                   )}
//                                 </div>
//                               )}
//                             </div>

//                             {/* Status and Toggle - Fixed at Bottom */}
//                             <div className="flex justify-between items-center mt-auto">
//                               <div className="flex items-center gap-2">
//                                 <span className="text-xs font-medium">
//                                   Status:
//                                 </span>
//                                 <span
//                                   className={`text-xs font-bold ${status.color}`}
//                                 >
//                                   {status.text}
//                                 </span>
//                               </div>
//                               <div className="flex items-center">
//                                 <input
//                                   type="checkbox"
//                                   id={`toggle-${post.blog_id}`}
//                                   checked={postStates[post.blog_id] || false}
//                                   onChange={() => handleToggle(post.blog_id)}
//                                   className="sr-only"
//                                 />
//                                 <label
//                                   htmlFor={`toggle-${post.blog_id}`}
//                                   className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors cursor-pointer ${
//                                     postStates[post.blog_id]
//                                       ? "bg-blue-600"
//                                       : "bg-gray-300"
//                                   }`}
//                                 >
//                                   <span
//                                     className={`inline-block w-4 h-4 transform transition-transform bg-white rounded-full ${
//                                       postStates[post.blog_id]
//                                         ? "translate-x-6"
//                                         : "translate-x-1"
//                                     }`}
//                                   />
//                                 </label>
//                               </div>
//                             </div>
//                           </div>
//                         </div>

                  
//                       </div>
//                     );
//                   })}
//                 </div>
//               )}
//                       {/* Bottom Center Pagination - Like the image style */}
//         {!loading && !error && filteredPosts && filteredPosts.length > 0 && totalPages > 1 && (
//           <div className="flex justify-center mt-8 mb-8">
//             <div className="flex items-center space-x-2">
//               {/* Previous button */}
//               <button
//                 onClick={goToPrevious}
//                 disabled={currentPage === 1}
//                 className="px-3 py-2 text-gray-500 hover:text-gray-700 disabled:opacity-30 disabled:cursor-not-allowed"
//               >
//                 &lt;
//               </button>

//               {/* Page numbers */}
//               {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//                 <button
//                   key={page}
//                   onClick={() => goToPage(page)}
//                   className={`w-10 h-10 rounded-md text-sm font-medium transition-all ${
//                     currentPage === page
//                       ? "  bg-blue-600 text-white"
//                       : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                   }`}
//                 >
//                   {page}
                 
//                 </button>
//               ))}

//               {/* Next button */}
//               <button
//                 onClick={goToNext}
//                 disabled={currentPage === totalPages}
//                 className="px-3 py-2 text-gray-500 hover:text-gray-700 disabled:opacity-30 disabled:cursor-not-allowed"
//               >
//                 &gt;
//               </button>
//             </div>
//           </div>
//         )}
//               {/* Empty State */}
//               {!loading && !error && displayPosts.length === 0 && (
//                 <div className="text-center py-16">
//                   <svg
//                     className="mx-auto h-12 w-12 text-gray-400"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                     />
//                   </svg>
//                   <h3 className="mt-2 text-sm font-medium text-gray-900">
//                     No blog posts
//                   </h3>
//                   <p className="mt-1 text-sm text-gray-500">
//                     Get started by creating your first blog post.
//                   </p>
//                   <div className="mt-6">
//                     <button
//                       onClick={() => setIsAddBlogOpen(true)}
//                       className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
//                     >
//                       <svg
//                         className="-ml-1 mr-2 h-5 w-5"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                       New Blog Post
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </>
//       )}
//       {/* Delete View */}
//       {currentView === "delete" && <BlogDelete onNavigate={handleNavigation} />}
//       {/* Archive View */}
//       {currentView === "archive" && (
//         <BlogArchive onNavigate={handleNavigation} />
//       )}
//       {/* Add Blog Modal */}
//       {isAddBlogOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">
//                   {isEditMode ? "Edit Blog Post" : "Add New Blog Post"}
//                 </h2>
//                 <button
//                   onClick={closeBlogPopup}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//               <form onSubmit={handleBlogSubmit} className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Title *
//                   </label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Content *
//                   </label>
//                   <RichTextEditor
//                     value={formData.content}
//                     onChange={(content) =>
//                       setFormData((prev) => ({ ...prev, content }))
//                     }
//                     placeholder="Write your blog content here..."
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Category *
//                   </label>
//                   {loadingCategories ? (
//                     <div className="flex items-center space-x-2">
//                       <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
//                       <span className="text-sm text-gray-500">
//                         Loading categories...
//                       </span>
//                     </div>
//                   ) : categoryError ? (
//                     <div className="text-red-600 text-sm">{categoryError}</div>
//                   ) : (
//                     <select
//                       name="category_id"
//                       value={formData.category_id}
//                       onChange={handleCategoryChange}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       required
//                     >
//                       <option value="">Select a category</option>
//                       {categories.map((category) => (
//                         <option
//                           key={category.category_id}
//                           value={category.category_id}
//                         >
//                           {category.category_name}
//                         </option>
//                       ))}
//                     </select>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Tags (comma-separated)
//                   </label>
//                   <input
//                     type="text"
//                     value={tagsInput}
//                     onChange={handleTagsChange}
//                     placeholder="e.g., jewelry, fashion, style"
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   {formData.tags.length > 0 && (
//                     <div className="mt-2 flex flex-wrap gap-1">
//                       {formData.tags.map((tag, index) => (
//                         <span
//                           key={index}
//                           className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                         >
//                           {tag}
//                           <button
//                             type="button"
//                             onClick={() => removeTag(index)}
//                             className="ml-1 text-blue-600 hover:text-blue-800"
//                           >
//                             ×
//                           </button>
//                         </span>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Main Image
//                   </label>
//                   <input
//                     type="file"
//                     accept="image/*"
//                     onChange={handleMainImageChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   {mainImagePreview && (
//                     <div className="mt-2">
//                       <img
//                         src={mainImagePreview}
//                         alt="Main image preview"
//                         className="w-32 h-32 object-cover rounded-md"
//                       />

//                     </div>
//                   )}
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Status
//                   </label>
//                   <select
//                     name="status"
//                     value={formData.status}
//                     onChange={handleInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   >
//                     <option value="draft">Draft</option>
//                     <option value="published">published</option>
//                   </select>
//                 </div>
//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={closeBlogPopup}
//                     className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
//                   >
//                     {isSubmitting
//                       ? isEditMode
//                         ? "Updating..."
//                         : "Creating..."
//                       : isEditMode
//                       ? "Update Blog"
//                       : "Create Blog"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Add Category Modal */}
//       {isAddCategoryOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-md w-full">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">Add New Category</h2>
//                 <button
//                   onClick={closeCategoryPopup}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>
//               <form onSubmit={handleCategorySubmit} className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Category Name *
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={categoryFormData.name}
//                     onChange={handleCategoryInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     required
//                   />
//                 </div>
//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={closeCategoryPopup}
//                     className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isSubmittingCategory}
//                     className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
//                   >
//                     {isSubmittingCategory ? "Creating..." : "Create Category"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Manage Categories Modal */}
//       {isManageCategoriesOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-md w-full max-h-[80vh] overflow-y-auto">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">Manage Categories</h2>
//                 <button
//                   onClick={closeManageCategories}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               {loadingCategoriesList ? (
//                 <div className="flex justify-center items-center py-8">
//                   <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
//                 </div>
//               ) : (
//                 <div className="space-y-2">
//                   {categoriesList.length > 0 ? (
//                     categoriesList.map((category) => (
//                       <div
//                         key={category.category_id}
//                         className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50"
//                       >
//                         <span className="font-medium">
//                           {category.category_name}
//                         </span>
//                         <div className="flex gap-2">
//                           <button
//                             onClick={() => handleEditCategory(category)}
//                             className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
//                           >
//                             Edit
//                           </button>
//                           <button
//                             onClick={() =>
//                               handleDeleteCategory(
//                                 category.category_id,
//                                 category.category_name
//                               )
//                             }
//                             className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700"
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="text-center py-8 text-gray-500">
//                       No categories found
//                     </div>
//                   )}
//                 </div>
//               )}

//               <div className="flex justify-end pt-4">
//                 <button
//                   onClick={closeManageCategories}
//                   className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Category Modal */}
//       {isEditCategoryOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg max-w-md w-full">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-semibold">Edit Category</h2>
//                 <button
//                   onClick={closeEditCategory}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <svg
//                     className="w-6 h-6"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               </div>

//               <form onSubmit={handleCategoryUpdate} className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Category Name *
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={categoryFormData.name}
//                     onChange={handleCategoryInputChange}
//                     className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     required
//                   />
//                 </div>

//                 <div className="flex justify-end space-x-3 pt-4">
//                   <button
//                     type="button"
//                     onClick={closeEditCategory}
//                     className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isSubmittingCategory}
//                     className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
//                   >
//                     {isSubmittingCategory ? "Updating..." : "Update Category"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Preview Modal */}
// {previewModal && previewPost && (
//   <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//     <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//       <div className="flex justify-between items-center p-6 border-b">
//         <h2 className="text-2xl font-bold text-gray-800">{previewPost.title}</h2>
//         <button
//           onClick={closePreviewModal}
//           className="text-gray-500 hover:text-gray-700 text-2xl"
//         >
//           ×
//         </button>
//       </div>
//       <div className="p-6">
//         <div className="flex gap-6">
//           <div className="flex-1">
//             <img
//               src={previewPost.main_image_url || "/placeholder-image.jpg"}
//               alt={previewPost.title}
//               className="w-full h-[30rem] object-cover rounded-lg mb-4"
//             />
//                <div className="flex items-center  gap-2 mb-4">
             
//               <span
//                 className={`px-2 py-1 rounded text-xs ${getCategoryColor(
//                   previewPost.category?.category_name
//                 )}`}
//               >
//                 {previewPost.category?.category_name || "Uncategorized"}
//               </span>
//           </div>
//           </div>
           
//           <div className="flex-1">
//             <div className="mb-4">
//               <p className="text-sm text-gray-500 mb-2">
//               • {new Date(previewPost.created_at).toLocaleDateString()}
//               </p>
//             </div>
//             <div className="prose max-w-none">
//               <div dangerouslySetInnerHTML={{ __html: previewPost.content || "No content available" }} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// )}

//     </div>
//   );
// };
// export default Blog;


import React, { useState, useEffect, useRef } from "react";
import BlogDelete from "./BlogDelete";
import BlogArchive from "./BlogArchive";
import { BASE_URL, DOMAIN_URL } from "../../config";
import axios from "axios";

// COMPLETELY REBUILT: Modern Rich Text Editor Component
const RichTextEditor = ({ value, onChange, placeholder }) => {
  const editorRef = useRef(null);
  const [activeFormats, setActiveFormats] = useState(new Set());

  useEffect(() => {
    if (editorRef.current && value !== editorRef.current.innerHTML) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const handleInput = () => {
    if (editorRef.current) {
      const content = editorRef.current.innerHTML;
      onChange(content);
      updateActiveFormats();
    }
  };

  const updateActiveFormats = () => {
    const formats = new Set();
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      let node = range.commonAncestorContainer;
      
      if (node.nodeType === Node.TEXT_NODE) {
        node = node.parentNode;
      }
      
      while (node && node !== editorRef.current) {
        const tagName = node.tagName?.toLowerCase();
        if (tagName === 'b' || tagName === 'strong') formats.add('bold');
        if (tagName === 'i' || tagName === 'em') formats.add('italic');
        if (tagName === 'u') formats.add('underline');
        if (tagName === 'strike' || tagName === 's') formats.add('strikethrough');
        if (tagName === 'ul') formats.add('bulletList');
        if (tagName === 'ol') formats.add('numberList');
        node = node.parentNode;
      }
    }
    setActiveFormats(formats);
  };

  const execCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    editorRef.current.focus();
    handleInput();
    setTimeout(updateActiveFormats, 10);
  };

  const insertBulletList = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      // Check if we're already in a list
      let currentNode = selection.anchorNode;
      while (currentNode && currentNode !== editorRef.current) {
        if (currentNode.tagName === 'UL' || currentNode.tagName === 'OL') {
          // Already in a list, toggle off
          execCommand('insertUnorderedList');
          return;
        }
        currentNode = currentNode.parentNode;
      }
      
      // Not in a list, create one
      execCommand('insertUnorderedList');
      
      // Ensure proper bullet styling
      setTimeout(() => {
        const lists = editorRef.current.querySelectorAll('ul');
        lists.forEach(list => {
          list.style.listStyleType = 'disc';
          list.style.paddingLeft = '20px';
          list.style.marginLeft = '0';
        });
      }, 10);
    }
  };

  const insertNumberList = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      let currentNode = selection.anchorNode;
      while (currentNode && currentNode !== editorRef.current) {
        if (currentNode.tagName === 'UL' || currentNode.tagName === 'OL') {
          execCommand('insertOrderedList');
          return;
        }
        currentNode = currentNode.parentNode;
      }
      
      execCommand('insertOrderedList');
      
      // Ensure proper numbering styling
      setTimeout(() => {
        const lists = editorRef.current.querySelectorAll('ol');
        lists.forEach(list => {
          list.style.listStyleType = 'decimal';
          list.style.paddingLeft = '20px';
          list.style.marginLeft = '0';
        });
      }, 10);
    }
  };

  const insertLink = () => {
    const selection = window.getSelection();
    const selectedText = selection.toString();
    
    if (selectedText) {
      const url = prompt('Enter URL:', 'https://');
      if (url && url.trim()) {
        execCommand('createLink', url);
        
        // Style the link
        setTimeout(() => {
          const links = editorRef.current.querySelectorAll('a');
          links.forEach(link => {
            link.style.color = '#2563eb';
            link.style.textDecoration = 'underline';
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
          });
        }, 10);
      }
    } else {
      alert('Please select some text first to create a link');
    }
  };

  const formatHeading = (level) => {
    execCommand('formatBlock', `h${level}`);
  };

  const insertHorizontalRule = () => {
    execCommand('insertHorizontalRule');
  };

  const clearFormatting = () => {
    execCommand('removeFormat');
  };

  const handleKeyDown = (e) => {
    // Handle keyboard shortcuts
    if (e.ctrlKey || e.metaKey) {
      switch (e.key) {
        case 'b':
          e.preventDefault();
          execCommand('bold');
          break;
        case 'i':
          e.preventDefault();
          execCommand('italic');
          break;
        case 'u':
          e.preventDefault();
          execCommand('underline');
          break;
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain');
    execCommand('insertText', text);
  };

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden bg-white">
      {/* Modern Toolbar with Icons */}
      <div className="flex flex-wrap gap-1 p-3 border-b border-gray-200 bg-gray-50">
        {/* Text Formatting */}
        <div className="flex gap-1 mr-2">
          <button
            type="button"
            onClick={() => execCommand('bold')}
            className={`px-3 py-2 border rounded-md hover:bg-gray-100 transition-colors text-sm font-semibold ${
              activeFormats.has('bold') ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-gray-300'
            }`}
            title="Bold (Ctrl+B)"
          >
            Bold
          </button>
          <button
            type="button"
            onClick={() => execCommand('italic')}
            className={`px-3 py-2 border rounded-md hover:bg-gray-100 transition-colors text-sm italic ${
              activeFormats.has('italic') ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-gray-300'
            }`}
            title="Italic (Ctrl+I)"
          >
            Italic
          </button>
          <button
            type="button"
            onClick={() => execCommand('underline')}
            className={`px-3 py-2 border rounded-md hover:bg-gray-100 transition-colors text-sm underline ${
              activeFormats.has('underline') ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-gray-300'
            }`}
            title="Underline (Ctrl+U)"
          >
            Underline
          </button>
          <button
            type="button"
            onClick={() => execCommand('strikeThrough')}
            className={`px-3 py-2 border rounded-md hover:bg-gray-100 transition-colors text-sm line-through ${
              activeFormats.has('strikethrough') ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-gray-300'
            }`}
            title="Strikethrough"
          >
            Strike
          </button>
        </div>

        <div className="w-px h-8 bg-gray-300 mx-2"></div>

        {/* Lists */}
        <div className="flex gap-1 mr-2">
          <button
            type="button"
            onClick={insertBulletList}
            className={`px-3 py-2 border rounded-md hover:bg-gray-100 transition-colors text-sm flex items-center gap-1 ${
              activeFormats.has('bulletList') ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-gray-300'
            }`}
            title="Bullet List"
          >
            <span className="text-lg leading-none">•</span>
            List
          </button>
          <button
            type="button"
            onClick={insertNumberList}
            className={`px-3 py-2 border rounded-md hover:bg-gray-100 transition-colors text-sm flex items-center gap-1 ${
              activeFormats.has('numberList') ? 'bg-blue-50 border-blue-300 text-blue-700' : 'border-gray-300'
            }`}
            title="Numbered List"
          >
            <span className="text-sm font-bold">1.</span>
            List
          </button>
        </div>

        <div className="w-px h-8 bg-gray-300 mx-2"></div>

        {/* Alignment */}
        <div className="flex gap-1 mr-2">
          <button
            type="button"
            onClick={() => execCommand('justifyLeft')}
            className="px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors text-sm"
            title="Align Left"
          >
            ←
          </button>
          <button
            type="button"
            onClick={() => execCommand('justifyCenter')}
            className="px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors text-sm"
            title="Align Center"
          >
            ↔
          </button>
          <button
            type="button"
            onClick={() => execCommand('justifyRight')}
            className="px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors text-sm"
            title="Align Right"
          >
            →
          </button>
        </div>

        <div className="w-px h-8 bg-gray-300 mx-2"></div>

        {/* Headings */}
        <div className="flex gap-1 mr-2">
          <select
            onChange={(e) => {
              if (e.target.value) {
                formatHeading(e.target.value);
                e.target.value = '';
              }
            }}
            className="px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors text-sm bg-white"
            title="Headings"
            defaultValue=""
          >
            <option value="">Heading</option>
            <option value="1">Heading 1</option>
            <option value="2">Heading 2</option>
            <option value="3">Heading 3</option>
            <option value="4">Heading 4</option>
          </select>
        </div>

        <div className="w-px h-8 bg-gray-300 mx-2"></div>

        {/* Additional Options */}
        <div className="flex gap-1">
          <button
            type="button"
            onClick={insertLink}
            className="px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors text-sm"
            title="Insert Link"
          >
            🔗 Link
          </button>
          <button
            type="button"
            onClick={insertHorizontalRule}
            className="px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors text-sm"
            title="Insert Line"
          >
            ➖ Line
          </button>
          <button
            type="button"
            onClick={clearFormatting}
            className="px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition-colors text-sm"
            title="Clear Formatting"
          >
            🗑️ Clear
          </button>
        </div>
      </div>

      {/* Enhanced Editor */}
      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        onMouseUp={updateActiveFormats}
        onKeyUp={updateActiveFormats}
        className="p-4 min-h-[250px] focus:outline-none text-left overflow-y-auto"
        style={{
          minHeight: "250px",
          maxHeight: "400px",
          lineHeight: "1.6",
          fontSize: "14px",
        }}
        data-placeholder={placeholder}
        suppressContentEditableWarning={true}
      />

      {/* Custom Styles for Lists */}
      <style jsx>{`
        [contenteditable] ul {
          list-style-type: disc !important;
          padding-left: 20px !important;
          margin: 10px 0 !important;
        }
        [contenteditable] ol {
          list-style-type: decimal !important;
          padding-left: 20px !important;
          margin: 10px 0 !important;
        }
        [contenteditable] li {
          margin: 5px 0 !important;
          display: list-item !important;
        }
        [contenteditable] h1 {
          font-size: 24px !important;
          font-weight: bold !important;
          margin: 15px 0 10px 0 !important;
        }
        [contenteditable] h2 {
          font-size: 20px !important;
          font-weight: bold !important;
          margin: 12px 0 8px 0 !important;
        }
        [contenteditable] h3 {
          font-size: 18px !important;
          font-weight: bold !important;
          margin: 10px 0 6px 0 !important;
        }
        [contenteditable] h4 {
          font-size: 16px !important;
          font-weight: bold !important;
          margin: 8px 0 4px 0 !important;
        }
        [contenteditable] a {
          color: #2563eb !important;
          text-decoration: underline !important;
        }
        [contenteditable] hr {
          border: none !important;
          border-top: 2px solid #e5e7eb !important;
          margin: 20px 0 !important;
        }
        [contenteditable] p {
          margin: 8px 0 !important;
        }
        [contenteditable]:empty:before {
          content: attr(data-placeholder);
          color: #9ca3af;
          font-style: italic;
        }
      `}</style>
    </div>
  );
};

const Blog = ({ dimension, fromTabs }) => {
  // Navigation state
  const [currentView, setCurrentView] = useState("home");
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openPostMenus, setOpenPostMenus] = useState({});
  const [postStates, setPostStates] = useState({});
  const menuRef = useRef(null);

  // Search state
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  // Blog form states
  const [isAddBlogOpen, setIsAddBlogOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    main_image_url: "",
    category_id: "",
    tags: [],
    status: "draft",
    is_archived: false,
  });

  // Category form states
  const [isAddCategoryOpen, setIsAddCategoryOpen] = useState(false);
  const [isSubmittingCategory, setIsSubmittingCategory] = useState(false);
  const [categoryFormData, setCategoryFormData] = useState({
    name: "",
  });

  // Category states
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [categoryError, setCategoryError] = useState("");

  // File handling states
  const [mainImageFile, setMainImageFile] = useState(null);
  const [thumbnailImageFile, setThumbnailImageFile] = useState(null);
  const [mainImagePreview, setMainImagePreview] = useState("");
  const [thumbnailImagePreview, setThumbnailImagePreview] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const [tagsInput, setTagsInput] = useState("");

  // Blog states
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [totalBlogs, setTotalBlogs] = useState(0);

  // Add these state variables after your existing states
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingBlogId, setEditingBlogId] = useState(null);
  const [editingBlogData, setEditingBlogData] = useState(null);

  // Add these new states for category management
  const [isManageCategoriesOpen, setIsManageCategoriesOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [isEditCategoryOpen, setIsEditCategoryOpen] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [loadingCategoriesList, setLoadingCategoriesList] = useState(false);

const [statusFilter, setStatusFilter] = useState("all");
const [sortBy, setSortBy] = useState("newest");

  const [previewModal, setPreviewModal] = useState(false);
const [previewPost, setPreviewPost] = useState(null);

const openPreviewModal = (post) => {
  setPreviewPost(post);
  setPreviewModal(true);
};

const closePreviewModal = () => {
  setPreviewModal(false);
  setPreviewPost(null);
};
  // FIXED: Fetch blogs function with proper loading check
  const fetchMyBlogs = async (page = 1, limit = itemsPerPage) => {
    // Prevent multiple simultaneous calls
    if (loading) return;

    setLoading(true);
    setError("");

    console.log("Fetching blogs with:", {
      page,
      limit,
      token: token ? "exists" : "missing",
    });

    try {
      const response = await axios.get(`${BASE_URL}/blogs/user/my-blogs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
        },
      });

      console.log("Blog API Response:", response.data);

      if (response.data && response.data.data) {
        // Filter out archived blogs from the main view
        const activeBlogs = response.data.data.filter((blog) => {
          // Handle both boolean and string values for is_archived
          const isArchived =
            blog.is_archived === true ||
            blog.is_archived === "true" ||
            blog.is_archived === 1;
          return !isArchived;
        });

        console.log("Original blogs count:", response.data.data.length);
        console.log("Active blogs count:", activeBlogs.length);
        console.log(
          "Filtered out archived blogs:",
          response.data.data.filter(
            (blog) =>
              blog.is_archived === true ||
              blog.is_archived === "true" ||
              blog.is_archived === 1
          )
        );

        
                setTotalBlogs(response.data.total || response.data.data.length);
        setBlogPosts(activeBlogs);
setTotalBlogs(response.data.total || response.data.data.length);

// FIX: Sync toggle status with real blog status
const statusMap = {};
activeBlogs.forEach((post) => {
  statusMap[post.blog_id] = post.status === "published";
});
setPostStates(statusMap);

      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      console.error("Error response:", error.response?.data);
      setError("Failed to load blogs");
      setBlogPosts([]);
    } finally {
      setLoading(false);
    }
  };
  // Add this state at the top of your component
  const [expandedTags, setExpandedTags] = useState({});
  // Add this function to handle tag expansion
  const toggleTagExpansion = (postId) => {
    setExpandedTags((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };

  // FIXED: Function to fetch categories
  const fetchCategories = async () => {
    setLoadingCategories(true);
    setCategoryError("");

    try {
      const response = await axios.get(`${BASE_URL}/blogs/categories`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        setCategories(response.data.data);
      } else {
        setCategories([]);
        setCategoryError(
          "No categories found. Please create a category first."
        );
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategoryError("Failed to load categories");
      setCategories([]);
    } finally {
      setLoadingCategories(false);
    }
  };

  // FIXED: Function to create category
  const createCategory = async (categoryData) => {
    setIsSubmittingCategory(true);

    try {
      const response = await axios.post(
        ` ${BASE_URL}/blogs/categories`,
        {
          name: categoryData.name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        setIsAddCategoryOpen(false);
        setCategoryFormData({ name: "" });
        await fetchCategories();
        alert("Category created successfully!");
        return response.data;
      }
    } catch (error) {
      console.error("Error creating category:", error);
      if (error.response) {
        alert(
          `Error: ${error.response.data.message || "Failed to create category"}`
        );
      } else {
        alert("Error creating category");
      }
    } finally {
      setIsSubmittingCategory(false);
    }
  };
  // Fetch all categories for management
  const fetchCategoriesForManagement = async () => {
    setLoadingCategoriesList(true);
    try {
    
      const response = await fetch(
        `${BASE_URL}/blogs/categories?page=1&limit=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        setCategoriesList(result.data || []);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoadingCategoriesList(false);
    }
  };

  // Handle edit category
  const handleEditCategory = (category) => {
    setEditingCategory(category);
    setCategoryFormData({ name: category.category_name });
    setIsEditCategoryOpen(true);
    setIsManageCategoriesOpen(false);
  };

  // Handle category update
  const handleCategoryUpdate = async (e) => {
    e.preventDefault();
    setIsSubmittingCategory(true);

    try {
     
      const response = await fetch(
        `${BASE_URL}/blogs/categories/${editingCategory.category_id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name: categoryFormData.name }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        alert(result.message || "Category updated successfully");
        setIsEditCategoryOpen(false);
        setEditingCategory(null);
        setCategoryFormData({ name: "" });
        fetchCategories(); // Refresh dropdown
        fetchCategoriesForManagement(); // Refresh management list
      } else {
        const error = await response.json();
        alert(error.message || "Failed to update category");
      }
    } catch (error) {
      console.error("Error updating category:", error);
      alert("Failed to update category");
    } finally {
      setIsSubmittingCategory(false);
    }
  };

  // Handle delete category
  const handleDeleteCategory = async (categoryId, categoryName) => {
    if (
      window.confirm(
        `Are you sure you want to delete "${categoryName}"? This action cannot be undone.`
      )
    ) {
      try {
        
        const response = await fetch(
          `${BASE_URL}/blogs/categories/${categoryId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const result = await response.json();
          alert(result.message || "Category deleted successfully");
          fetchCategories(); // Refresh dropdown
          fetchCategoriesForManagement(); // Refresh management list
        } else {
          const error = await response.json();
          alert(error.message || "Failed to delete category");
        }
      } catch (error) {
        console.error("Error deleting category:", error);
        alert("Failed to delete category");
      }
    }
  };
// Add these helper functions after your existing state declarations
const formatDate = (dateString) => {
  if (!dateString) return "Unknown date";
  
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch (error) {
    return "Invalid date";
  }
};

const stripHtml = (html) => {
  if (!html) return "";
  
  try {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  } catch (error) {
    return "";
  }
};
  // Open category management modal
  const openManageCategories = () => {
    setIsManageCategoriesOpen(true);
    fetchCategoriesForManagement();
  };

  // Close category management modal
  const closeManageCategories = () => {
    setIsManageCategoriesOpen(false);
    setCategoriesList([]);
  };

  // Close edit category modal
  const closeEditCategory = () => {
    setIsEditCategoryOpen(false);
    setEditingCategory(null);
    setCategoryFormData({ name: "" });
  };
  // FIXED: Search functionality with debouncing
  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      if (searchTerm.trim()) {
        const filtered = blogPosts.filter(
          (post) =>
            post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (post.category?.category_name &&
              post.category.category_name
                .toLowerCase()
                .includes(searchTerm.toLowerCase()))
        );
        setSearchResults(filtered);
      } else {
        setSearchResults([]);
      }
    }, 300);

    return () => clearTimeout(delayedSearch);
  }, [searchTerm, blogPosts]);

  // FIXED: Fetch blogs when page changes - THIS IS THE KEY FIX
  useEffect(() => {
    if (currentView === "home") {
      fetchMyBlogs(currentPage, itemsPerPage);
    }
  }, [currentPage, currentView, token]);

  // Fetch categories when add blog modal opens
  useEffect(() => {
    if (isAddBlogOpen) {
      fetchCategories();
    }
  }, [isAddBlogOpen]);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (!event.target.closest(".post-menu")) {
      setOpenPostMenus({});
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  // Reset pagination when view changes
  useEffect(() => {
    setCurrentPage(1);
  }, [currentView]);

  // Navigation handler
  const handleNavigation = (view) => {
    if (view !== currentView) {
      setIsAnimating(true);
      setIsMenuOpen(false);
      setTimeout(() => {
        setCurrentView(view);
        setIsAnimating(false);
      }, 150);
    } else {
      setIsMenuOpen(false);
    }
  };

  // Handle post menu toggle
  const togglePostMenu = (postId) => {
    setOpenPostMenus((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };

  // // Handle post actions
  // const handlePostAction = (action, postId) => {
  //   console.log(`${action} post:`, postId);
  //   setOpenPostMenus({});
  // };
  // Update the handlePostAction function
  // Replace your handlePostAction function with this:
  const handlePostAction = async (action, postId) => {
    console.log("handlePostAction called:", action, postId); // Debug log
    setOpenPostMenus({});
    if (action === "edit") {
      handleEditBlog(postId);
      return;
    }
    if (action === "delete") {
      try {
        // Use the token that's already available in the component scope
        console.log("Token found:", token ? "YES" : "NO"); // Debug log
        console.log("Attempting to soft delete blog:", postId); // Debug log

        const response = await fetch(`${BASE_URL}/blogs/${postId}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Use the token from component scope
          },
        });

        console.log("Delete response status:", response.status); // Debug log

        if (response.ok) {
          const result = await response.json();
          console.log("Blog soft deleted successfully:", result);

          // Refresh the blog list
          await fetchMyBlogs(currentPage, itemsPerPage);

          alert("Blog post moved to trash successfully");
        } else {
          const errorData = await response.json();
          console.error("Failed to delete blog post:", errorData);
          alert("Failed to delete blog post: " + errorData.message);
        }
      } catch (error) {
        console.error("Error deleting blog post:", error);
        alert("Error deleting blog post: " + error.message);
      }
    }
    // Handle archive action
    if (action === "archive") {
      // Show confirmation dialog
      const confirmed = window.confirm(
        "Are you sure you want to archive this blog post?"
      );

      if (!confirmed) {
        return;
      }
      try {
        console.log("Token found:", token ? "YES" : "NO");
        console.log("Attempting to archive blog:", postId);

        const response = await fetch(`${BASE_URL}/blogs/${postId}/archive`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Archive response status:", response.status);
        if (response.ok) {
          const result = await response.json();
          console.log("Blog archived successfully:", result);

          // Refresh the blog list
          await fetchMyBlogs(currentPage, itemsPerPage);

          alert("Blog post archived successfully!");
        } else {
          const errorData = await response.json();
          console.error("Failed to archive blog post:", errorData);
          alert("Failed to archive blog post: " + errorData.message);
        }
      } catch (error) {
        console.error("Error archiving blog post:", error);
        alert("Error archiving blog post: " + error.message);
      }
    }
  };

  // Add this function after your handlePostAction function
  const handleEditBlog = async (blogId) => {
    console.log("Editing blog:", blogId);

    try {
      // Find the blog data from current posts
      const blogToEdit = currentPosts.find((post) => post.blog_id === blogId);

      if (!blogToEdit) {
        alert("Blog not found");
        return;
      }

      console.log("Blog to edit:", blogToEdit);

      // Set form data with existing blog data
      setFormData({
        title: blogToEdit.title || "",
        content: blogToEdit.content || "",
        main_image_url: blogToEdit.main_image_url || "",
        category_id: blogToEdit.category_id || "",
        tags: blogToEdit.tags || [],
        status: blogToEdit.status || "draft",
        is_archived: blogToEdit.is_archived || false,
      });

      // Set tags input for display
      setTagsInput(blogToEdit.tags ? blogToEdit.tags.join(", ") : "");

      // Set edit mode
      setIsEditMode(true);
      setEditingBlogId(blogId);
      setEditingBlogData(blogToEdit);

      // Set main image preview if exists
      if (blogToEdit.main_image_url) {
        setMainImagePreview(blogToEdit.main_image_url);
      }

      // Open the blog form modal
      setIsAddBlogOpen(true);

      // Fetch categories for the form
      fetchCategories();
    } catch (error) {
      console.error("Error preparing blog for edit:", error);
      alert("Error loading blog for editing");
    }
  };

  const handleToggle = async (blogId) => {
    try {

      const currentPost = displayPosts.find((post) => post.blog_id === blogId);
      const currentStatus = currentPost?.status || "draft";
      const newStatus = currentStatus === "draft" ? "published" : "draft";

      const response = await fetch(
        `${BASE_URL}/blogs/${blogId}/toggle-status`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ status: newStatus }),
        }
      );

      if (response.ok) {
        // Update local state
        setPostStates((prev) => ({
          ...prev,
          [blogId]: newStatus === "published",
        }));

        // Show confirmation message
        const message =
          newStatus === "published"
            ? "Blog post published successfully!"
            : "Blog post saved as draft!";

        alert(message); // Or use toast notification

        // Refresh the blog list
        fetchMyBlogs(currentPage, itemsPerPage);
      }
    } catch (error) {
      console.error("Error updating blog status:", error);
      alert("Failed to update blog status");
    }
  };
  // Get status text and color
  const getStatusDisplay = (postId) => {
    const isOn = postStates[postId];
    return {
      text: isOn ? "Published" : "Draft",
      color: isOn ? "text-green-600" : "text-gray-400",
    };
  };

  // FIXED: Get display posts for server-side pagination
  const getDisplayPosts = () => {
    if (searchTerm.trim()) {
      return blogPosts.filter(
        (post) =>
          (post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (post.category?.category_name &&
              post.category.category_name
                .toLowerCase()
                .includes(searchTerm.toLowerCase()))) &&
          (post.status === "draft" || post.status === "published")
      );
    }
    return blogPosts.filter(
      (post) => post.status === "draft" || post.status === "published"
    );
  };

  const displayPosts = getDisplayPosts();

  // FIXED: Server-side pagination - DON'T slice the data again
  const currentPosts = displayPosts; // Use all posts from current page

  // FIXED: Calculate total pages from server response
  const totalPages = Math.max(1, Math.ceil(totalBlogs / itemsPerPage));

  // FIXED: Pagination handlers
  const goToPage = (page) => {
    setCurrentPage(page);
    // fetchMyBlogs will be called automatically by useEffect
  };

  const goToPrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Color gradients for fallback
  const gradients = [
    "from-pink-100 to-pink-200",
    "from-orange-100 to-orange-200",
    "from-green-100 to-green-200",
    "from-purple-100 to-purple-200",
    "from-blue-100 to-blue-200",
    "from-yellow-100 to-yellow-200",
  ];

  // Category colors for badges
  const getCategoryColor = (category) => {
    const colors = {
      Rings: "bg-purple-50 text-purple-600",
      Bracelets: "bg-blue-50 text-blue-600",
      Bangles: "bg-green-50 text-green-600",
      Necklaces: "bg-pink-50 text-pink-600",
      gold: "bg-yellow-50 text-yellow-600",
      Chains: "bg-indigo-50 text-indigo-600",
      Pendants: "bg-red-50 text-red-600",
    };
    return colors[category] || "bg-yellow-50 text-yellow-600";
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle category form input changes
  const handleCategoryInputChange = (e) => {
    const { name, value } = e.target;
    setCategoryFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle category selection
  const handleCategoryChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      category_id: e.target.value,
    }));
  };

  // Handle tags input
  const handleTagsChange = (e) => {
    const inputValue = e.target.value;
    setTagsInput(inputValue);

    const tags = inputValue
      .split(",")
      .map((tag) => tag.trim())
      .filter((tag) => tag)
      .filter((tag, index, arr) => arr.indexOf(tag) === index);

    setFormData((prev) => ({
      ...prev,
      tags: tags,
    }));
  };

  // Remove individual tag
  const removeTag = (indexToRemove) => {
    const newTags = formData.tags.filter((_, index) => index !== indexToRemove);
    setFormData((prev) => ({
      ...prev,
      tags: newTags,
    }));
    setTagsInput(newTags.join(", "));
  };

  // FIXED: Handle search input
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);

    // If search is cleared, fetch fresh data
    if (!e.target.value.trim()) {
      fetchMyBlogs(1, itemsPerPage);
    }
  };

  // Handle main image file selection
  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
      if (!allowedTypes.includes(file.type)) {
        alert("Please select a valid image file (JPEG, PNG, or WebP)");
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        alert("File size must be less than 10MB");
        return;
      }

      setMainImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setMainImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle thumbnail image file selection
  const handleThumbnailImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnailImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setThumbnailImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Update your existing closeBlogPopup function
  const closeBlogPopup = () => {
    setIsAddBlogOpen(false);

    // Reset form data
    setFormData({
      title: "",
      content: "",
      main_image_url: "",
      category_id: "",
      tags: [],
      status: "draft",
      is_archived: false,
    });

    // Reset all states
    setTagsInput("");
    setMainImageFile(null);
    setThumbnailImageFile(null);
    setMainImagePreview("");
    setThumbnailImagePreview("");
    setCategoryError("");
    setCategories([]);

    // Reset edit mode
    setIsEditMode(false);
    setEditingBlogId(null);
    setEditingBlogData(null);
  };

  // Close category popup
  const closeCategoryPopup = () => {
    setIsAddCategoryOpen(false);
    setCategoryFormData({
      name: "",
    });
  };
const cleanTags = (tagsInput) => {
  if (!tagsInput) return [];

  if (Array.isArray(tagsInput)) {
    return tagsInput.map(tag => tag.trim()).filter(Boolean);
  }

  return tagsInput
    .split(',')
    .map(tag => tag.trim())
    .filter(tag => tag.length > 0);
};

  const handleBlogSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      alert("Please enter a title");
      return;
    }

    if (!formData.content.trim()) {
      alert("Please enter content");
      return;
    }

    if (!formData.category_id) {
      alert("Please select a category");
      return;
    }

    setIsSubmitting(true);

    try {
      const cleanedTags = cleanTags(formData.tags);
      console.log("Cleaned tags:", cleanedTags);

      const hasImages = mainImageFile || thumbnailImageFile;

      if (!hasImages) {
        // No images - use JSON
        const jsonData = {
          title: formData.title,
          content: formData.content,
          category_id: formData.category_id,
          tags: cleanedTags.length > 0 ? cleanedTags : undefined,
          status: formData.status,
          is_archived: false, // FIXED: Always false for new blogs
        };

        console.log("Sending JSON data:", jsonData);

        // Choose endpoint based on edit mode
        const url = isEditMode
          ? `${BASE_URL}/blogs/${editingBlogId}`
          : `${BASE_URL}/blogs`;
        const method = isEditMode ? "PATCH" : "POST";

        const response = await axios({
          method,
          url,
          data: jsonData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200 || response.status === 201) {
          closeBlogPopup();
          alert(
            isEditMode
              ? "Blog updated successfully!"
              : "Blog created successfully!"
          );
          fetchMyBlogs(currentPage, itemsPerPage);
        }
      } else {
        // With images - use FormData
        const submitData = new FormData();
        submitData.append("title", formData.title);
        submitData.append("content", formData.content);
        submitData.append("category_id", formData.category_id);
        submitData.append("status", formData.status);
        submitData.append("is_archived", "false"); // FIXED: Always false for new blogs

        if (cleanedTags.length > 0) {
          cleanedTags.forEach((tag) => {
            submitData.append("tags", tag);
          });
        }

        if (mainImageFile) {
          submitData.append("main_image", mainImageFile);
        }

        if (thumbnailImageFile) {
          submitData.append("thumbnail_image", thumbnailImageFile);
        }

        console.log("Sending FormData with tags:", cleanedTags);

        // Choose endpoint based on edit mode
        const url = isEditMode
          ? `${BASE_URL}/blogs/${editingBlogId}`
          : `${BASE_URL}/blogs`;
        const method = isEditMode ? "PATCH" : "POST";

        const response = await axios({
          method,
          url,
          data: submitData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.status === 200 || response.status === 201) {
          closeBlogPopup();
          alert(
            isEditMode
              ? "Blog updated successfully!"
              : "Blog created successfully!"
          );
          fetchMyBlogs(currentPage, itemsPerPage);
        }
      }
    } catch (error) {
      console.error("Error with blog operation:", error);
      if (error.response) {
        console.error("Full response data:", error.response.data);
        if (error.response.data && error.response.data.message) {
          console.error(
            "Detailed error messages:",
            error.response.data.message
          );
        }
        alert(
          `Error: ${JSON.stringify(
            error.response.data.message || "Operation failed"
          )}`
        );
      } else {
        alert("Error with blog operation");
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  // Submit category form
  const handleCategorySubmit = async (e) => {
    e.preventDefault();

    if (!categoryFormData.name.trim()) {
      alert("Please enter a category name");
      return;
    }

    await createCategory(categoryFormData);
  };
const getFilteredPosts = () => {
  if (!displayPosts || displayPosts.length === 0) {
    return [];
  }

  let filtered = [...displayPosts];

  // Filter by status only
  if (statusFilter !== "all") {
    filtered = filtered.filter(post => {
      if (statusFilter === "published") {
        return post.status === "published";
      } else if (statusFilter === "draft") {
        return post.status === "draft";
      }
      return true;
    });
  }

  // Sort posts
  filtered.sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);

    if (sortBy === "newest") {
      return dateB - dateA;
    } else if (sortBy === "oldest") {
      return dateA - dateB;
    } else if (sortBy === "title") {
      return a.title.localeCompare(b.title);
    }
    return 0;
  });

  return filtered;
};
  const filteredPosts = getFilteredPosts();
  return (
    <div className=" flex flex-col bg-gray-50">
      {/* Only show header and main content when on home page */}
      {currentView === "home" && (
        <>
          {/* Header */}
          <div className="flex-shrink-0 bg-white shadow-sm border-b">
            <div className="px-6 py-4">
              <div className="flex items-center justify-between">
                {/* Tab Navigation */}
<div className="flex bg-gray-100 rounded-lg p-1">
  <button
    onClick={() => handleNavigation("home")}
    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
      currentView === "home"
        ? "bg-white text-blue-600 shadow-sm"
        : "text-gray-600 hover:text-gray-800"
    }`}
  >
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
      />
    </svg>
    Home
  </button>

  <button
    onClick={() => handleNavigation("delete")}
    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
      currentView === "delete"
        ? "bg-white text-red-600 shadow-sm"
        : "text-gray-600 hover:text-gray-800"
    }`}
  >
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
    Deleted
  </button>

  <button
    onClick={() => handleNavigation("archive")}
    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
      currentView === "archive"
        ? "bg-white text-yellow-600 shadow-sm"
        : "text-gray-600 hover:text-gray-800"
    }`}
  >
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h14a2 2 0 002-2V8m-9 4h4"
      />
    </svg>
    Archive
  </button>
</div>
                {/* Action Buttons */}
                <div className="flex gap-4">
                  <button
                    onClick={() => setIsAddBlogOpen(true)}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    Add Blog
                  </button>
                  <button
                    onClick={() => setIsAddCategoryOpen(true)}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
                  >
                    Add Category
                  </button>
                  <button
                    onClick={openManageCategories}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
                  >
                    Manage Categories
                  </button>

                  {/* Search Bar */}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      className="pl-4 pr-10 py-2 border border-gray-300 rounded w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button className="absolute right-2 top-1/2 transform -translate-y-1/2">
                      <svg
                        className="w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Main Content */}
          <div className="flex-1 overflow-auto">
            <div
              className={`px-6 py-6 transition-all duration-300 ${
                isAnimating
                  ? "opacity-50 transform translate-x-4"
                  : "opacity-100 transform translate-x-0"
              }`}
            >
              <div className="mb-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <h2 className="text-xl font-semibold text-gray-800">
                      Blog Posts
                    </h2>
                    {!loading && displayPosts.length > 0 && (
                      <span className="text-sm text-gray-600">
                        Page {currentPage} of {totalPages} ({totalBlogs} total
                        blogs)
                      </span>
                    )}
                  </div>

              
                </div>
              </div>
              {/* Loading State */}
              {loading && (
                <div className="flex justify-center items-center py-16">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                </div>
              )}
              {/* Error State */}
              {error && (
                <div className="text-center py-16">
                  <p className="text-red-600 text-lg">{error}</p>
                  <button
                    onClick={() => fetchMyBlogs(currentPage, itemsPerPage)}
                    className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  >
                    Try Again
                  </button>
                </div>
              )}
              {/* Blog Posts Grid */}
              {/* Blog Posts Grid */}
              {!loading && !error && displayPosts.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
                  {displayPosts.map((post, index) => {
                    const status = getStatusDisplay(post.blog_id);
                    return (
                      <div
                        key={post.blog_id}
                        className="group relative"
                        style={{ minHeight: "420px" }} // Fixed height for consistency
                      >
                        {/* Main Card - Fixed Structure */}
                        <div
                          className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer relative"
                          style={{
                            minHeight: "530px",
                            height: expandedTags[post.blog_id]
                              ? "auto"
                              : "420px",
                          }}
                        >
                          {/* Post Menu Button */}
                          <div className="absolute top-3 right-3 z-10">
                       <button
  onClick={() => togglePostMenu(post.blog_id)}
  className="p-2 bg-white/95  hover:bg-gray-100 rounded-full transition-colors"
>
  <svg
    className="w-5 h-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 5v.01M12 12v.01M12 19v.01"
    />
  </svg>
</button>

                            {/* Dropdown Menu */}
                            {openPostMenus[post.blog_id] && (
                              <div className="absolute top-full right-0 mt-2 w-32 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden post-menu">
                                <div className="py-2">
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handlePostAction("edit", post.blog_id);
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-blue-600"
                                  >
                                    Edit
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handlePostAction("archive", post.blog_id);
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-yellow-600"
                                  >
                                    Archive
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handlePostAction("delete", post.blog_id);
                                    }}
                                    className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors text-red-600"
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>

                {/* Image - Fixed Height */}
<div className="relative group" style={{ height: "300px" }}>
  {post.main_image_url ? (
    <img
      src={post.main_image_url}
      alt={post.title}
      className="w-full h-full object-cover"
    />
  ) : (
    <div
      className={`w-full h-full bg-gradient-to-br ${
        gradients[index % gradients.length]
      } flex items-center justify-center`}
    >
      <span className="text-gray-500 text-lg font-medium">
        No Image
      </span>
    </div>
  )}
  {/* Eye Icon Overlay - positioned below kebab menu */}
<div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
  <button
    onClick={(e) => {
      e.stopPropagation();
      openPreviewModal(post);
    }}
    className="bg-white/95 p-2 rounded-full hover:bg-gray-100 transition-colors mt-12 shadow-md"
    style={{ marginTop: '50px' }} // Position below kebab menu
  >
    <svg
      className="w-5 h-5 text-gray-700"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      />
    </svg>
  </button>
</div>
</div>

                          {/* Content - Fixed Layout */}
                          <div
                            className="p-4 flex flex-col"
                            style={{
                              minHeight: "220px",
                              height: expandedTags[post.blog_id]
                                ? "auto"
                                : "220px",
                            }}
                          >
                            <div className="flex justify-between items-start text-xs text-gray-600 mb-2">
                              <span
                                className={`px-2 py-1 rounded text-xs ${getCategoryColor(
                                  post.category?.category_name
                                )}`}
                              >
                                {post.category?.category_name ||
                                  "Uncategorized"}
                              </span>
                              <span>
                                {new Date(post.created_at).toLocaleDateString()}
                              </span>
                            </div>

                            <h3
                              className="font-semibold text-gray-800 mb-3 text-sm text-center line-clamp-2"
                              style={{ height: "40px" }}
                            >
                              {post.title}
                            </h3>
                            {/* Tags - Dynamic Height Container */}
                            <div
                              className="mb-3"
                              style={{
                                minHeight: "60px",
                                height: expandedTags[post.blog_id]
                                  ? "auto"
                                  : "60px",
                                overflow: expandedTags[post.blog_id]
                                  ? "visible"
                                  : "hidden",
                              }}
                            >
                              {post.tags && post.tags.length > 0 && (
                                <div className="flex flex-wrap gap-1">
                                  {expandedTags[post.blog_id]
                                    ? post.tags.map((tag, tagIndex) => (
                                        <span
                                          key={tagIndex}
                                          className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
                                        >
                                          {tag}
                                        </span>
                                      ))
                                    : post.tags
                                        .slice(0, 4)
                                        .map((tag, tagIndex) => (
                                          <span
                                            key={tagIndex}
                                            className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
                                          >
                                            {tag}
                                          </span>
                                        ))}
                                  {post.tags.length > 4 && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleTagExpansion(post.blog_id);
                                      }}
                                      className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full hover:bg-gray-200 transition-colors"
                                    >
                                      {expandedTags[post.blog_id]
                                        ? "Show less"
                                        : `+${post.tags.length - 4}`}
                                    </button>
                                  )}
                                </div>
                              )}
                            </div>

                            {/* Status and Toggle - Fixed at Bottom */}
                            <div className="flex justify-between items-center mt-auto">
                              <div className="flex items-center gap-2">
                                <span className="text-xs font-medium">
                                  Status:
                                </span>
                                <span
                                  className={`text-xs font-bold ${status.color}`}
                                >
                                  {status.text}
                                </span>
                              </div>
                              <div className="flex items-center">
                                <input
                                  type="checkbox"
                                  id={`toggle-${post.blog_id}`}
                                  checked={postStates[post.blog_id] || false}
                                  onChange={() => handleToggle(post.blog_id)}
                                  className="sr-only"
                                />
                                <label
                                  htmlFor={`toggle-${post.blog_id}`}
                                  className={`relative inline-flex items-center h-6 rounded-full w-11 transition-colors cursor-pointer ${
                                    postStates[post.blog_id]
                                      ? "bg-blue-600"
                                      : "bg-gray-300"
                                  }`}
                                >
                                  <span
                                    className={`inline-block w-4 h-4 transform transition-transform bg-white rounded-full ${
                                      postStates[post.blog_id]
                                        ? "translate-x-6"
                                        : "translate-x-1"
                                    }`}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                  
                      </div>
                    );
                  })}
                </div>
              )}
                      {/* Bottom Center Pagination - Like the image style */}
        {!loading && !error && filteredPosts && filteredPosts.length > 0 && totalPages > 1 && (
          <div className="flex justify-center mt-8 mb-8">
            <div className="flex items-center space-x-2">
              {/* Previous button */}
              <button
                onClick={goToPrevious}
                disabled={currentPage === 1}
                className="px-3 py-2 text-gray-500 hover:text-gray-700 disabled:opacity-30 disabled:cursor-not-allowed"
              >
                &lt;
              </button>

              {/* Page numbers */}
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  onClick={() => goToPage(page)}
                  className={`w-10 h-10 rounded-md text-sm font-medium transition-all ${
                    currentPage === page
                      ? "  bg-blue-600 text-white"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                >
                  {page}
                 
                </button>
              ))}

              {/* Next button */}
              <button
                onClick={goToNext}
                disabled={currentPage === totalPages}
                className="px-3 py-2 text-gray-500 hover:text-gray-700 disabled:opacity-30 disabled:cursor-not-allowed"
              >
                &gt;
              </button>
            </div>
          </div>
        )}
              {/* Empty State */}
              {!loading && !error && displayPosts.length === 0 && (
                <div className="text-center py-16">
                  <svg
                    className="mx-auto h-12 w-12 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <h3 className="mt-2 text-sm font-medium text-gray-900">
                    No blog posts
                  </h3>
                  <p className="mt-1 text-sm text-gray-500">
                    Get started by creating your first blog post.
                  </p>
                  <div className="mt-6">
                    <button
                      onClick={() => setIsAddBlogOpen(true)}
                      className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
                    >
                      <svg
                        className="-ml-1 mr-2 h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      New Blog Post
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
      {/* Delete View */}
      {currentView === "delete" && <BlogDelete onNavigate={handleNavigation} />}
      {/* Archive View */}
      {currentView === "archive" && (
        <BlogArchive onNavigate={handleNavigation} />
      )}
      {/* Add Blog Modal */}
      {isAddBlogOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">
                  {isEditMode ? "Edit Blog Post" : "Add New Blog Post"}
                </h2>
                <button
                  onClick={closeBlogPopup}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <form onSubmit={handleBlogSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Title *
                  </label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Content *
                  </label>
                  <RichTextEditor
                    value={formData.content}
                    onChange={(content) =>
                      setFormData((prev) => ({ ...prev, content }))
                    }
                    placeholder="Write your blog content here..."
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Category *
                  </label>
                  {loadingCategories ? (
                    <div className="flex items-center space-x-2">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                      <span className="text-sm text-gray-500">
                        Loading categories...
                      </span>
                    </div>
                  ) : categoryError ? (
                    <div className="text-red-600 text-sm">{categoryError}</div>
                  ) : (
                    <select
                      name="category_id"
                      value={formData.category_id}
                      onChange={handleCategoryChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    >
                      <option value="">Select a category</option>
                      {categories.map((category) => (
                        <option
                          key={category.category_id}
                          value={category.category_id}
                        >
                          {category.category_name}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tags (comma-separated)
                  </label>
                  <input
                    type="text"
                    value={tagsInput}
                    onChange={handleTagsChange}
                    placeholder="e.g., jewelry, fashion, style"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  {formData.tags.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-1">
                      {formData.tags.map((tag, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
                        >
                          {tag}
                          <button
                            type="button"
                            onClick={() => removeTag(index)}
                            className="ml-1 text-blue-600 hover:text-blue-800"
                          >
                            ×
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Main Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleMainImageChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  {mainImagePreview && (
                    <div className="mt-2">
                      <img
                        src={mainImagePreview}
                        alt="Main image preview"
                        className="w-32 h-32 object-cover rounded-md"
                      />

                    </div>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="draft">Draft</option>
                    <option value="published">published</option>
                  </select>
                </div>
                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={closeBlogPopup}
                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                  >
                    {isSubmitting
                      ? isEditMode
                        ? "Updating..."
                        : "Creating..."
                      : isEditMode
                      ? "Update Blog"
                      : "Create Blog"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Add Category Modal */}
      {isAddCategoryOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Add New Category</h2>
                <button
                  onClick={closeCategoryPopup}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <form onSubmit={handleCategorySubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Category Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={categoryFormData.name}
                    onChange={handleCategoryInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={closeCategoryPopup}
                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmittingCategory}
                    className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
                  >
                    {isSubmittingCategory ? "Creating..." : "Create Category"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Manage Categories Modal */}
      {isManageCategoriesOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Manage Categories</h2>
                <button
                  onClick={closeManageCategories}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {loadingCategoriesList ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                </div>
              ) : (
                <div className="space-y-2">
                  {categoriesList.length > 0 ? (
                    categoriesList.map((category) => (
                      <div
                        key={category.category_id}
                        className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50"
                      >
                        <span className="font-medium">
                          {category.category_name}
                        </span>
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleEditCategory(category)}
                            className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() =>
                              handleDeleteCategory(
                                category.category_id,
                                category.category_name
                              )
                            }
                            className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      No categories found
                    </div>
                  )}
                </div>
              )}

              <div className="flex justify-end pt-4">
                <button
                  onClick={closeManageCategories}
                  className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Category Modal */}
      {isEditCategoryOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Edit Category</h2>
                <button
                  onClick={closeEditCategory}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <form onSubmit={handleCategoryUpdate} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Category Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={categoryFormData.name}
                    onChange={handleCategoryInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={closeEditCategory}
                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmittingCategory}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                  >
                    {isSubmittingCategory ? "Updating..." : "Update Category"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Preview Modal */}
{previewModal && previewPost && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
      <div className="flex justify-between items-center p-6 border-b">
        <h2 className="text-2xl font-bold text-gray-800">{previewPost.title}</h2>
        <button
          onClick={closePreviewModal}
          className="text-gray-500 hover:text-gray-700 text-2xl"
        >
          ×
        </button>
      </div>
      <div className="p-6">
        <div className="flex gap-6">
          <div className="flex-1">
            <img
              src={previewPost.main_image_url || "/placeholder-image.jpg"}
              alt={previewPost.title}
              className="w-full h-[30rem] object-cover rounded-lg mb-4"
            />
                  <div className="flex items-center  gap-2 mb-4">
             
              <span
                className={`px-2 py-1 rounded text-xs ${getCategoryColor(
                  previewPost.category?.category_name
                )}`}
              >
                {previewPost.category?.category_name || "Uncategorized"}
              </span>
          </div>
          </div>
          <div className="flex-1">
            <div className="mb-4">
              <p className="text-sm text-gray-500 mb-2">
              • {new Date(previewPost.created_at).toLocaleDateString()}
              </p>
            </div>
            <div className="prose max-w-none">
              <div dangerouslySetInnerHTML={{ __html: previewPost.content || "No content available" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};
export default Blog;
